var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function () {
    angular.module('QMC.Home', ['QMC.Aufgaben', 'QMC.Fachleistung', 'ui.router']);
})();
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var HomeController = /** @class */ (function () {
            /**
             * QMC.Home.HomeController
             * @constructor
             * @param $timeout
             * @param $qui
             * @param fachleistungService
             * @param $scope
             * @param terminService
             * @param lng
             */
            function HomeController($location, $timeout, $qui, fachleistungService, $scope, terminService, userService, lng, permissionService, $state) {
                var _this = this;
                this.$location = $location;
                this.$timeout = $timeout;
                this.$qui = $qui;
                this.fachleistungService = fachleistungService;
                this.$scope = $scope;
                this.terminService = terminService;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.$state = $state;
                this.canModifyReportText = false;
                this.showPlaned = false;
                this.showRaw = false;
                this.birthdayWidget = false;
                this.awayWidget = false;
                this.appointmentWidget = true;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    _this.events();
                    $(".help-block").parent("div").attr("style", "");
                });
                userService.getUserSettings(["LANDINGPAGE", "GLOBAL.LANDINGPAGE", "FLS.CASE.DAYSTOHIGHLIGHT", "FLS.CONTINGENT.DONTSHOWINDRECT", "LANDINGPAGE.LOGO", "BIRTHDAY.WIDGET.ACTIVE", "AWAY.WIDGET.ACTIVE", "APPOINTMENT.WIDGET.ACTIVE", "FLS.PLANEDRAWDAYS", "FLS.PLANEDDAYSFUTURE"], true).then(function (data) {
                    _this.$qui.waitForEl('#navLogo', function () {
                        var landingpage = '';
                        if (data[1].value !== (undefined || null) && data[1].value !== "") {
                            landingpage = data[1].value;
                        }
                        if (data[0].value !== (undefined || null) && data[0].value !== "") {
                            landingpage = data[0].value;
                        }
                        if (landingpage.length > 0 && landingpage !== 'dashboard') {
                            if (data[4].value.toLowerCase() === 'true') {
                                $('#navLogo').attr('href', '#' + landingpage);
                                localStorage.setItem('logo', '#' + landingpage);
                            }
                            else {
                                localStorage.removeItem('logo');
                                $('#navLogo').attr('href', '#');
                            }
                            if (window.sessionStorage.getItem("RecentlyLoggedIn") !== "true") {
                                var path = window.location.href.substring(0, window.location.href.indexOf('#'));
                                window.location.href = path + '#' + landingpage;
                                window.sessionStorage.setItem("RecentlyLoggedIn", "true");
                            }
                        }
                        else {
                            localStorage.removeItem('logo');
                            $('#navLogo').attr('href', '#');
                        }
                        _this.birthdayWidget = data[5].value.toLowerCase() === 'true';
                        _this.awayWidget = data[6].value.toLowerCase() === 'true';
                        _this.appointmentWidget = data[7].value.toLowerCase() === 'true' || data[7].value.length === 0;
                        _this.userService.getGlobalSettings(['FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED', 'FLS.ALLOWEMPTYREPORTS']).then(function (globalData) {
                            var days = parseInt(data[8].value);
                            if (isNaN(days) || days === null || days === undefined)
                                days = QMC.Common.UserSettingConstantsAndDefaults.PLANEDRAWDAYS;
                            var daysFuture = parseInt(data[9].value);
                            if (isNaN(daysFuture) || daysFuture === null || daysFuture === undefined)
                                daysFuture = QMC.Common.UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE;
                            if (globalData[0].value.toLocaleLowerCase() === 'true')
                                _this.showRaw = daysFuture >= 0 && globalData[1].value.toLocaleLowerCase() === 'true';
                            _this.showPlaned = days >= 0;
                            _this.showRaw = daysFuture >= 0;
                            if (_this.showPlaned || _this.showRaw)
                                _this.GetPlanedAndRawDocumentations(days, daysFuture);
                        });
                    });
                    window.sessionStorage.setItem("RecentlyLoggedIn", "true");
                    //Get the permission to modify reporttext
                    _this.permissionService.getPermissionsByObjectTypes([230020]).then(function (data) {
                        _this.canModifyReportText = data[0].modify; //is user allowed to change reporttext (in german: Berichtstexte )
                    });
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            HomeController.prototype.GetMiniWidgetClasses = function () {
                // count active widgets
                var count = 0;
                if (this.canModifyReportText && this.showRaw) // raw docu
                    count++;
                if (this.showPlaned) // planed docu
                    count++;
                if (this.birthdayWidget) // birthdays
                    count++;
                if (this.awayWidget) // away
                    count++;
                var even = Math.floor(12 / count);
                return "col-md-" + even + " col-sm-" + this.getSmMiniWidgetColSpan(even);
            };
            HomeController.prototype.getSmMiniWidgetColSpan = function (span) {
                span = span * 2;
                if (span < 12 && span > 6)
                    span = 6;
                return span;
            };
            /**
             * Sidebar Event
             * @description Toggle between table and card view
             */
            HomeController.prototype.events = function () {
                if (window.innerWidth > 1299) {
                    this.affixAgent();
                }
            };
            /**
             * checkForDatetime
             * @description Check for the current daytime, like morning ...
             */
            HomeController.prototype.checkForDatetime = function () {
                var date = new Date();
                var h = date.getHours();
                if ((h >= 0) && (h <= 10))
                    return this.lng.translate(20000040, 'Morgen <br>');
                if ((h > 10) && (h <= 17))
                    return this.lng.translate(20000041, 'Tag');
                else
                    return this.lng.translate(20000042, 'Abend');
            };
            /**
             * sayHello
             * @description Send a notification to the view
             */
            HomeController.prototype.sayHello = function () {
                var dayTime = this.checkForDatetime();
                var greet = this.lng.translate(20000043, "Guten") + " " + dayTime;
                var note = {
                    title: $('#session').data().fullName,
                    message: greet,
                    icon: 'qm-icon-bell',
                    status: 'default',
                    timer: 3000,
                    delay: 1500
                };
                if (!$('body').hasClass('greeted')) {
                    $('body').addClass('greeted');
                    this.$qui.notify(note);
                }
            };
            /**
            * affixAgent
            * @description
            * @param null
            */
            HomeController.prototype.affixAgent = function () {
                var width = $("#rightbar").width() - 1;
                $("#rightbar").css("right", 0);
                $("#rightbar").width(width);
                $('#rightbar').affix({
                    offset: {
                        top: 166
                    }
                });
                $('#rightbar')
                    .on('affix-top.bs.affix', function () {
                    $("#rightbar").css("right", 0);
                    $("#rightbar").width(width);
                }).on('affix.bs.affix', function () {
                    if ($("#rightbar .scroller").height() > (window.innerHeight - 166))
                        $("#rightbar .scroller").css("overflow-y", "auto").css("max-height", (window.innerHeight - 166));
                });
            };
            /**
             * currentFilter
             * @description Check if the current filter is enabled
             * @param entry
             */
            HomeController.prototype.currentfilter = function (entry) {
                console.log(entry);
                var filterActive = $('#filterActive').val();
                if (filterActive === 'true')
                    return entry.isCurrent;
                else
                    return true;
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * GetPlanedDocumentations
             * @description Gets all planed but not docuemented documentations in the past x days.
             */
            HomeController.prototype.GetPlanedAndRawDocumentations = function (days, daysFuture) {
                var _this = this;
                if (this.showPlaned)
                    this.fachleistungService.getPlannedDocumentations(days, daysFuture).then(function (data) {
                        _this.planedDocumentations = data;
                    });
                if (this.showRaw)
                    this.fachleistungService.getRawDocumentations(days).then(function (data) {
                        _this.rawDocumentations = data;
                    });
            };
            HomeController.prototype.setStandardNavTemp = function () {
                this.userService.getNavigation(QMC.Common.Constants.DEFAULT_NAV_ID).then(function (data) {
                    window.createNav(data);
                    //window.localStorage.setItem("NAVIGATION", Common.Constants.DEFAULT_NAV_ID);
                    setTimeout(function () {
                        $("#side-menu").metisMenu('dispose');
                        $('#side-menu').metisMenu();
                    }, 250);
                });
            };
            HomeController = __decorate([
                QMC.Controller('QMC.Home', 'HomeController'),
                QMC.Inject('$location', '$timeout', '$qui', 'FachleistungService', '$scope', 'TerminService', 'UserService', 'QmcLanguageService', 'QmcPermissionService', '$state')
            ], HomeController);
            return HomeController;
        }());
        Home.HomeController = HomeController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var NavConfigurationController = /** @class */ (function () {
            /////////////////////////// Constructor //////////////////////////
            function NavConfigurationController($qui, $scope, $state, userService, lng, $timeout) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.lng = lng;
                this.$timeout = $timeout;
                this.isSavingNav = false;
                this.newContainerName = "";
                this.qmIcons = [];
                this.selectedIcon = "";
                this.notSupported = false;
                this.selectedFileNames = [];
                this.uploads = [];
                this.importName = "";
                $qui.init("einstellungen", function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    _this.events();
                });
                if (this.checkIe()) {
                    this.notSupported = true;
                    return;
                }
                var styleSheets = document.styleSheets;
                for (var i = 0; i < styleSheets.length; i++)
                    for (var j = 0; j < styleSheets[i].cssRules.length; j++)
                        if (styleSheets[i].cssRules[j].selectorText != (null || undefined) && styleSheets[i].cssRules[j].selectorText.startsWith(".qm-icon-")) {
                            var iconName = styleSheets[i].cssRules[j].selectorText;
                            this.qmIcons.push(iconName.substr(1, iconName.indexOf(":") - 1));
                        }
                this.init();
                this.loading = true;
                this.getAvailableNavs();
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            NavConfigurationController.prototype.init = function () {
                var _this = this;
                this.userService.getUserSettings(["NAVIGATION.WEB"]).then(function (data) {
                    _this.selectedNavId = _this.getSettingValue("NAVIGATION.WEB", QMC.Common.Constants.DEFAULT_NAV_ID, data).toLowerCase();
                    _this.loadNav();
                    _this.loading = false;
                });
                this.navColors = window.bodyColorClasses.split(' ');
                //remove login
                this.navColors.shift();
            };
            NavConfigurationController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.selectedNavId', function () { _this.loadNav(); });
                this.$scope.$watch('vm.selectedFileNames', function () { _this.stripSuffix(); }, true);
            };
            NavConfigurationController.prototype.favToggle = function (id) {
                if (this.checkIfFav(id))
                    this.currentNav.subNav = this.removeFromNavigationRecursive(id, this.currentNav.subNav).list;
                else
                    this.currentNav.subNav.push(this.convertNavigationPageItemToNavigationItem(this.getNavItemById(id), this.getNavColorByTargetIdRecursive(id, this.currentNav.mainNav)));
                this.createPreview();
            };
            NavConfigurationController.prototype.checkIfFav = function (id) {
                for (var i = 0; i < this.currentNav.subNav.length; i++)
                    if (this.currentNav.subNav[i].navigationItemId === id)
                        return true;
                return false;
            };
            NavConfigurationController.prototype.toggleIcon = function (icon) {
                this.selectedIcon = icon;
            };
            NavConfigurationController.prototype.createNewContainer = function () {
                $('#createContainerModal').modal('hide');
                var isSecondLevel = false;
                //Check if we got a secound level container
                if (this.newContainerParentId !== "configPreview") {
                    var found = false;
                    for (var i = 0; i < this.currentNav.mainNav.length; i++) {
                        if (this.currentNav.mainNav[i].navigationItemId === this.newContainerParentId) {
                            found = true;
                            break;
                        }
                    }
                    isSecondLevel = !found;
                }
                //createContainer Object
                var container = {
                    color: this.newContainerColor,
                    icon: this.selectedIcon,
                    link: "",
                    navigationItemId: QMC.Common.Constants.GUID_EMPTY,
                    subItems: [{
                            color: this.newContainerColor,
                            icon: "",
                            link: "placeholder",
                            navigationItemId: this.generateGuid(),
                            subItems: [],
                            title: "",
                            type: 0
                        }],
                    title: this.newContainerName,
                    type: isSecondLevel ? 2 : 1
                };
                this.addItemToNav(this.newContainerParentId, container);
                this.createPreview();
                this.$qui.scopeApply(this.$scope);
            };
            ////////////////////////////// DnD ///////////////////////////////
            NavConfigurationController.prototype.initDnd = function () {
                if (this.currentNav.isFix)
                    return;
                var dndDropTargets = document.querySelectorAll('.drop-target');
                var dndDraggables = document.querySelectorAll('[draggable=true]');
                for (var i = 0; i < dndDropTargets.length; i++) {
                    if (!dndDropTargets[i].classList.contains("setupDT")) {
                        dndDropTargets[i].classList.add("setupDT");
                        dndDropTargets[i].addEventListener('dragenter', this.handleNavElementDragEnter, false);
                        dndDropTargets[i].addEventListener('dragleave', this.handleNavElementDragLeave, false);
                        dndDropTargets[i].addEventListener('dragover', this.handleNavElementDragOver, false);
                        dndDropTargets[i].addEventListener('drop', this.handleNavElementDrop.bind(this, this), false);
                    }
                }
                for (var i = 0; i < dndDraggables.length; i++) {
                    if (!dndDraggables[i].classList.contains("setupDR")) {
                        dndDraggables[i].classList.add("setupDR");
                        dndDraggables[i].addEventListener('dragstart', this.handleDragStart, false);
                        dndDraggables[i].addEventListener('dragend', this.handleNavElementDragEnd, false);
                    }
                }
            };
            NavConfigurationController.prototype.handleDragStart = function (e) {
                console.log("drag start", e);
                e.target.style.opacity = '0.4'; // e.target is the source node.
                e.dataTransfer.setData('id', e.target.id);
                e.dataTransfer.setData('type', e.target.type);
                e.dataTransfer.effectAllowed = 'move';
                if (e.target.classList.contains("nav-element")) {
                    e.dataTransfer.setData("source", "candidate");
                    e.dataTransfer.setData("candidate", "");
                }
                if (e.target.classList.contains("nav-container-container")) {
                    e.dataTransfer.setData("source", "container");
                    e.dataTransfer.setData("container", "");
                }
                if (e.target.classList.contains("nav-config-item")) {
                    e.dataTransfer.setData("source", "navigation");
                    e.dataTransfer.setData("navigation", "");
                }
            };
            NavConfigurationController.prototype.handleNavElementDragOver = function (e) {
                //console.log("drag over", e);
                if (e.preventDefault)
                    e.preventDefault(); // Necessary. Allows us to drop.
                return false;
            };
            NavConfigurationController.prototype.handleNavElementDragEnter = function (e) {
                //console.log("drag enter", e);
                // if the target has no id its properly not our real target but a child of it. so we iterate its parents till we find one with an id
                var target = e.target;
                while (target.id == (null || undefined || "")) {
                    target = target.parentNode;
                }
                var isValidTarget = false;
                console.log("checking if target is valid for drop", target, e.dataTransfer.types);
                //if (e.dataTransfer.types.includes("navigation"))
                isValidTarget =
                    (e.dataTransfer.types.includes("navigation") && (target.id === "configPreview" || target.id === "navElementContainer" || target.id === "navContainerContainer" || target.classList.contains("nav-container-container") || target.classList.contains("nav-config-item") || target.classList.contains("nav-element"))) ||
                        (e.dataTransfer.types.includes("candidate") && (target.id === "configPreview" || target.id === "navElementContainer" || target.classList.contains("nav-config-item") || target.classList.contains("nav-element"))) ||
                        (e.dataTransfer.types.includes("container") && (target.id === "configPreview" || target.classList.contains("nav-config-item")));
                e.preventDefault();
                if (target.classList.contains("drop-target") && isValidTarget) {
                    target.style.borderBottom = "thick solid orange";
                    e.dataTransfer.dropEffect = "move";
                }
                else {
                    e.dataTransfer.dropEffect = "none";
                }
            };
            NavConfigurationController.prototype.handleNavElementDragLeave = function (e) {
                //console.log("drag leave", e);
                e.preventDefault();
                e.target.style.borderBottom = "unset";
            };
            NavConfigurationController.prototype.handleNavElementDragEnd = function (e) {
                //console.log("drag end", e);
                e.preventDefault();
                var dndDropTargets = document.querySelectorAll('.drop-target');
                for (var i = 0; i < dndDropTargets.length; i++) {
                    dndDropTargets[i].style.borderBottom = "unset";
                    e.target.style.opacity = "unset";
                }
            };
            NavConfigurationController.prototype.handleNavElementDrop = function (_scope, e) {
                e.preventDefault();
                e.stopPropagation();
                var dropId = e.dataTransfer.getData('id');
                var dropType = e.dataTransfer.getData('type');
                var dropSource = e.dataTransfer.getData('source');
                // if the target has no id its properly not our real target but a child of it. so we iterate its parents till we find one with an id
                var target = e.target;
                while (target.id == (null || undefined || "")) {
                    target = target.parentNode;
                }
                console.log("drop data ID:", dropId, "TYPE:", dropType, "SOURCE:", dropSource, "DROP TARGET:", e.target, "PROPOSED TARGET", target);
                //move from navigation to candidate list
                if (dropType == 0 && dropSource == "navigation" && (target.id === "navElementContainer" || target.parentNode.id === "navElementContainer")) {
                    console.log("dropped nav item into candidate list");
                    // remove item form navigation and add it to candidate list
                    this.removeFromNavigation(dropId);
                    //than push element to candidate array
                    this.addItemToCandidates(dropId);
                }
                //move from navigation to container list
                if ((dropType == 1 || dropType == 2) && dropSource == "navigation" && (target.classList.contains("nav-container-container") || target.id == "navContainerContainer")) {
                    console.log("dropped container from nav to container list");
                    //readd items to candidate list
                    this.addSubItemsToCandidates(this.getItemFromNavRecursive(dropId, this.currentNav.mainNav).subItems);
                    // remove container and its childs form navigation
                    this.removeFromNavigation(dropId);
                }
                //move from candidate list to nav
                if (dropType == 0 && dropSource == "candidate" && (target.id === "configPreview" || target.classList.contains("nav-config-item"))) {
                    console.log("dropped item from candidate to nav", target.tagName.toLowerCase());
                    //if we're dropping to the container put the item first, else place it after the target
                    this.addItemToNav(target.id, this.convertNavigationPageItemToNavigationItem(this.getNavItemById(dropId), "login"));
                    //remove item from candidate list
                    this.removeItemFromCandidate(dropId);
                }
                //move item or container inside the nav
                if (dropSource == "navigation" && target.classList.contains("nav-config-item") && (dropId != target.id) && !this.checkIfIdChildInNav(dropId, target.id)) {
                    console.log("dropped item from nav to the nav (hopefully in another place, otherwise this would be completely pointless)");
                    this.addItemToNav(target.id, this.removeFromNavigation(dropId));
                    // if something was a subcontainer before, it now becomes type 1
                    this.fixContainerTypes(this.currentNav.mainNav, false);
                }
                //add new container
                if (dropSource == "container" && (target.id === "configPreview" || target.classList.contains("nav-config-item"))) {
                    this.newContainerParentId = target.id;
                    this.newContainerColor = dropId;
                    this.newContainerName = "";
                    this.selectedIcon = "";
                    $('#createContainerModal').modal('show');
                }
                // fix favs
                var itemsToToggle = [];
                for (var i = 0; i < this.currentNav.subNav.length; i++) {
                    //let favItem = this.currentNav.subNav[i];
                    var navItem = this.getItemFromNavRecursive(this.currentNav.subNav[i].navigationItemId, this.currentNav.mainNav);
                    this.currentNav.subNav[i].type = 3;
                    if (navItem == (null || undefined))
                        itemsToToggle.push(this.currentNav.subNav[i].navigationItemId);
                    //this.favToggle(favItem.navigationItemId);
                    else
                        this.currentNav.subNav[i].color = navItem.color;
                }
                for (var i = 0; i < itemsToToggle.length; i++)
                    this.favToggle(itemsToToggle[i]);
                this.createPreview();
                this.$qui.scopeApply(this.$scope);
            };
            ///////////////////////// DnD Helpers ////////////////////////////
            NavConfigurationController.prototype.addItemToNav = function (targetId, itemToAdd) {
                if (targetId === "configPreview")
                    this.currentNav.mainNav.unshift(itemToAdd);
                else
                    this.currentNav.mainNav = this.addItemToNavRecursive(targetId, this.currentNav.mainNav, itemToAdd);
            };
            NavConfigurationController.prototype.addItemToNavRecursive = function (targetId, navArray, itemToAdd) {
                //find target in current nav
                for (var i = 0; i < navArray.length; i++) {
                    if (navArray[i].navigationItemId === targetId) {
                        var index = i;
                        if (navArray.length > i)
                            index++;
                        if (navArray[i].link === "placeholder")
                            navArray.splice(index - 1, 1, itemToAdd);
                        else
                            navArray.splice(index, 0, itemToAdd);
                        return navArray;
                    }
                    else if (navArray[i].subItems != (null || undefined)) {
                        var copiedItemToAdd = angular.copy(itemToAdd);
                        copiedItemToAdd.color = navArray[i].color;
                        navArray[i].subItems = this.addItemToNavRecursive(targetId, navArray[i].subItems, copiedItemToAdd);
                    }
                }
                return navArray;
            };
            NavConfigurationController.prototype.getNavItemById = function (id) {
                for (var i = 0; i < this.navigationItems.length; i++)
                    if (this.navigationItems[i].id === id)
                        return this.navigationItems[i];
                return null;
            };
            NavConfigurationController.prototype.convertNavigationPageItemToNavigationItem = function (item, color) {
                return {
                    color: color,
                    icon: item.icon,
                    link: item.link,
                    navigationItemId: item.id,
                    subItems: [],
                    title: this.lng.translate(item.languageTag, item.title),
                    type: 0
                };
            };
            NavConfigurationController.prototype.getNavColorByTargetIdRecursive = function (id, array) {
                var result = null;
                for (var i = 0; i < array.length; i++) {
                    if (array[i].navigationItemId === id)
                        return array[i].color;
                    if (array[i].subItems != (null || undefined))
                        result = this.getNavColorByTargetIdRecursive(id, array[i].subItems);
                    if (result)
                        return result;
                }
                return result;
            };
            NavConfigurationController.prototype.addSubItemsToCandidates = function (array) {
                for (var i = 0; i < array.length; i++)
                    if (array[i].subItems == (null || undefined) || array[i].subItems.length === 0)
                        this.addItemToCandidates(array[i].navigationItemId);
                    else
                        this.addSubItemsToCandidates(array[i].subItems);
            };
            NavConfigurationController.prototype.addItemToCandidates = function (id) {
                var item;
                for (var i = 0; i < this.navigationItems.length; i++)
                    if (this.navigationItems[i].id == id) {
                        item = this.navigationItems[i];
                        break;
                    }
                if (item !== (null || undefined))
                    this.navigationCandidates.push(item);
                this.navigationCandidates.sort(function (a, b) {
                    var textA = a.title.toUpperCase();
                    var textB = b.title.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
                this.$qui.scopeApply(this.$scope);
            };
            NavConfigurationController.prototype.removeFromNavigation = function (id) {
                var result = this.removeFromNavigationRecursive(id, this.currentNav.mainNav);
                this.currentNav.mainNav = result.list;
                return result.item;
            };
            NavConfigurationController.prototype.removeFromNavigationRecursive = function (id, itemList) {
                var item;
                // try to find item by id
                for (var i = 0; i < itemList.length; i++) {
                    if (itemList[i].navigationItemId === id) {
                        item = itemList[i];
                        var list = itemList.filter(function (obj) {
                            return obj.navigationItemId !== id;
                        });
                        return { list: list, item: item };
                    }
                    else if (itemList[i].subItems != (null || undefined)) {
                        var recursiveResult = this.removeFromNavigationRecursive(id, itemList[i].subItems);
                        itemList[i].subItems = recursiveResult.list;
                        if (recursiveResult.item != (null || undefined))
                            return { list: itemList, item: recursiveResult.item };
                    }
                }
                return { list: itemList, item: item };
            };
            NavConfigurationController.prototype.removeItemFromCandidate = function (id) {
                for (var i = 0; i < this.navigationCandidates.length; i++) {
                    if (this.navigationCandidates[i].id === id) {
                        var spliceReturn = this.navigationCandidates.splice(i, 1);
                    }
                }
            };
            //////////////////////// CREATE ELEMENTS /////////////////////////
            NavConfigurationController.prototype.createPreview = function () {
                var _this = this;
                var previewUl = document.getElementById('configPreview');
                var favArea = document.getElementById('favoriteConfig');
                // wait till preview is ready
                if (previewUl !== null && previewUl !== undefined) {
                    // remove current preview
                    while (previewUl.firstChild) {
                        previewUl.removeChild(previewUl.firstChild);
                    }
                    while (favArea.firstChild) {
                        favArea.removeChild(favArea.firstChild);
                    }
                    this.createPreviewForSubItems(previewUl, this.currentNav.mainNav);
                    this.createSubNav(favArea, this.currentNav.subNav);
                    //add this to make sure the background box is big enough (dirty little cheat)
                    var placeholder = document.createElement("div");
                    placeholder.setAttribute("style", "display: table; width: 100%;");
                    favArea.appendChild(placeholder);
                    this.initDnd();
                    return;
                }
                setTimeout(function () { _this.createPreview(); }, 100);
            };
            NavConfigurationController.prototype.createPreviewForSubItems = function (parentUl, items, is2ndLvl) {
                if (is2ndLvl === void 0) { is2ndLvl = false; }
                for (var i = 0; i < items.length; i++) {
                    switch (items[i].type) {
                        case 1:
                            // first level container
                            this.create1stLvlNavContainer(parentUl, items[i]);
                            break;
                        case 2:
                            // second level container
                            this.create2ndLvlNavContainer(parentUl, items[i]);
                            break;
                        case 0:
                        default:
                            // link
                            this.createNavItem(parentUl, items[i], is2ndLvl);
                            break;
                    }
                }
            };
            NavConfigurationController.prototype.createNavItem = function (parentUl, item, is2ndLvl) {
                if (is2ndLvl === void 0) { is2ndLvl = false; }
                var li = document.createElement("li");
                var spanFav = document.createElement("span");
                var imageFav = document.createElement("i");
                if (item.link !== "placeholder")
                    if (this.checkIfFav(item.navigationItemId))
                        imageFav.setAttribute("class", "fa fa-star qm-nav-config-fav-button");
                    else
                        imageFav.setAttribute("class", "fa fa-star-o qm-nav-config-fav-button");
                if (!this.currentNav.isFix)
                    imageFav.onclick = function () { this.favToggle(item.navigationItemId); }.bind(this, this);
                spanFav.appendChild(imageFav);
                li.appendChild(spanFav);
                if (!is2ndLvl) {
                    var span = document.createElement("span");
                    var spanImage = document.createElement("span");
                    var image = document.createElement("i");
                    image.setAttribute("class", item.icon);
                    spanImage.appendChild(image);
                    li.appendChild(spanImage);
                    li.appendChild(span);
                    span.appendChild(document.createTextNode(item.title));
                }
                else {
                    li.appendChild(document.createTextNode(item.title));
                }
                li.setAttribute("draggable", "true");
                li.setAttribute("class", "nav-config-item drop-target");
                li.setAttribute("id", item.navigationItemId);
                li.setAttribute("type", "0");
                parentUl.appendChild(li);
                // remove item from element list
                this.navigationCandidates = this.navigationCandidates.filter(function (obj) {
                    return obj.id !== item.navigationItemId;
                });
            };
            NavConfigurationController.prototype.create1stLvlNavContainer = function (parent, item) {
                var li = document.createElement("li");
                li.setAttribute("class", "nav-config-item drop-target qm-nav-config-colored-" + item.color);
                var containerId = this.generateGuid();
                li.setAttribute("id", containerId);
                item.navigationItemId = containerId;
                var imageSpan = document.createElement("span");
                var image = document.createElement("i");
                image.setAttribute("class", item.icon);
                var span = document.createElement("span");
                span.appendChild(document.createTextNode(item.title));
                imageSpan.appendChild(image);
                li.appendChild(imageSpan);
                li.appendChild(span);
                var ul = document.createElement("ul");
                ul.setAttribute("class", "nav-config-item qm-nav-config-colored-ul-" + item.color);
                li.setAttribute("type", "1");
                li.appendChild(ul);
                parent.appendChild(li);
                li.setAttribute("draggable", "true");
                this.createPreviewForSubItems(ul, item.subItems);
            };
            NavConfigurationController.prototype.create2ndLvlNavContainer = function (parent, item) {
                var li = document.createElement("li");
                var containerId = this.generateGuid();
                li.setAttribute("id", containerId);
                item.navigationItemId = containerId;
                var spanImage = document.createElement("span");
                spanImage.setAttribute("style", "margin-left: 36px;");
                var image = document.createElement("i");
                image.setAttribute("class", item.icon);
                var span = document.createElement("span");
                span.appendChild(document.createTextNode(item.title));
                var arrow = document.createElement("span");
                arrow.setAttribute("class", "fa arrow pull-right");
                spanImage.appendChild(image);
                li.appendChild(spanImage);
                li.appendChild(span);
                li.appendChild(arrow);
                var ul = document.createElement("ul");
                li.setAttribute("type", "2");
                li.appendChild(ul);
                parent.appendChild(li);
                li.setAttribute("draggable", "true");
                li.setAttribute("class", "nav-config-item drop-target");
                ul.setAttribute("draggable", "true");
                ul.setAttribute("class", "nav-config-item drop-target");
                this.createPreviewForSubItems(ul, item.subItems, true);
            };
            NavConfigurationController.prototype.createSubNav = function (parent, items) {
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var itemContainer = document.createElement("div");
                    itemContainer.setAttribute("class", "nav-item-" + i);
                    itemContainer.setAttribute("id", "nav-item-" + i);
                    var div = document.createElement("div");
                    div.setAttribute("class", "desktop qm-nav-config-fav nav-fav-" + item.color);
                    var iconSpan = document.createElement("span");
                    iconSpan.setAttribute("class", "qm-tab " + item.icon);
                    div.appendChild(iconSpan);
                    var textSpan = document.createElement("span");
                    textSpan.appendChild(document.createTextNode(item.title));
                    div.appendChild(textSpan);
                    itemContainer.appendChild(div);
                    parent.appendChild(itemContainer);
                }
            };
            NavConfigurationController.prototype.checkIfIdChildInNav = function (parentId, childId) {
                var parent = this.getItemFromNavRecursive(parentId, this.currentNav.mainNav);
                if (parent.subItems == (null || undefined))
                    return false;
                var child = this.getItemFromNavRecursive(childId, parent.subItems);
                return child != (null || undefined);
            };
            //////////////////////// SERVICEFUNCTION /////////////////////////
            NavConfigurationController.prototype.getSettingValue = function (key, defaultValue, settings) {
                return $.grep(settings, function (e) { return e.key === key; })[0].value === "" ? defaultValue : $.grep(settings, function (e) { return e.key === key; })[0].value;
            };
            NavConfigurationController.prototype.swap = function (inputArray, index_A, index_B) {
                var temp = inputArray[index_A];
                inputArray[index_A] = inputArray[index_B];
                inputArray[index_B] = temp;
                return inputArray;
            };
            NavConfigurationController.prototype.generateGuid = function () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            };
            NavConfigurationController.prototype.getItemFromNavRecursive = function (id, list) {
                var result;
                for (var i = 0; i < list.length; i++) {
                    if (list[i].navigationItemId == id) {
                        result = list[i];
                        break;
                    }
                    else if (list[i].subItems != (null || undefined) && result == (null || undefined))
                        result = this.getItemFromNavRecursive(id, list[i].subItems);
                }
                return result;
            };
            NavConfigurationController.prototype.fixContainerTypes = function (list, isSub, color) {
                if (color === void 0) { color = "login"; }
                for (var i = 0; i < list.length; i++) {
                    if (list[i].type == 1 && isSub)
                        list[i].type = 2;
                    if (list[i].type == 2 && !isSub)
                        list[i].type = 1;
                    if (list[i].type == 0)
                        list[i].color = color;
                    if (list[i].subItems != (null || undefined))
                        this.fixContainerTypes(list[i].subItems, true, list[i].color);
                }
            };
            ///////////////////////// Immport/Exprt //////////////////////////
            NavConfigurationController.prototype.exportNav = function () {
                // get navi name
                var name = "navigation";
                for (var i = 0; i < this.navs.length; i++) {
                    if (this.navs[i].id === this.selectedNavId) {
                        name = this.navs[i].caption;
                        break;
                    }
                }
                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify({
                    mainNav: this.currentNav.mainNav,
                    subNav: this.currentNav.subNav
                })));
                element.setAttribute('download', name + ".webnav");
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            };
            NavConfigurationController.prototype.openImportModal = function () {
                $('#importNavModal').modal('show');
                this.openFileSelector();
            };
            NavConfigurationController.prototype.openFileSelector = function () {
                this.selectedFileNames = [];
                this.uploads = [];
                var fileSelector = angular.element('#fileselect');
                fileSelector.click();
                if (this.checkIe())
                    for (var file in fileSelector[0].files)
                        this.selectedFileNames.push(fileSelector[0].files[file].name);
            };
            NavConfigurationController.prototype.stripSuffix = function () {
                if (this.selectedFileNames.length === 0 || this.selectedFileNames[0].indexOf(".webnav") < 1)
                    return;
                this.importName = this.selectedFileNames[0].substring(0, this.selectedFileNames[0].indexOf(".webnav"));
            };
            NavConfigurationController.prototype.checkIe = function () {
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                }
                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    var rv = ua.indexOf('rv:');
                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                }
                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                }
                // other browser
                return false;
            };
            NavConfigurationController.prototype.setFile = function () {
                var _this = this;
                if (this.uploads.length === 0)
                    return;
                this.loading = true;
                $('#importNavModal').modal('hide');
                // file input creates automatically a base64 including mimetype, we only need the base64 part
                // we don't use basic atob for it has problems with utf
                var base64 = this.b64DecodeUnicode(this.uploads[0].substring(this.uploads[0].indexOf("base64") + 7, this.uploads[0].length));
                var imported = JSON.parse(base64);
                this.userService.postNewNavigation({ caption: this.importName, mainNav: imported.mainNav, subNav: imported.subNav }).then(function (data) {
                    _this.getAvailableNavs();
                    _this.selectedNavId = data.createdObjectId;
                    _this.loadNav();
                }).finally(function () {
                    _this.loading = false;
                });
            };
            NavConfigurationController.prototype.b64DecodeUnicode = function (str) {
                // Going backwards: from bytestream, to percent-encoding, to original string.
                return decodeURIComponent(atob(str).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            NavConfigurationController.prototype.loadNav = function () {
                var _this = this;
                this.loadingNav = true;
                if (this.currentNav != undefined)
                    this.currentNav.isFix = false;
                this.userService.getNavigationItems().then(function (data) {
                    for (var i = 0; i < data.length; i++)
                        data[i].title = _this.lng.translate(data[i].languageTag, data[i].title);
                    _this.navigationItems = data;
                    _this.navigationCandidates = angular.copy(data);
                    _this.userService.getNavigation(_this.selectedNavId).then(function (data) {
                        if (data.mainNav == (null || undefined))
                            data.mainNav = [];
                        if (data.subNav == (null || undefined))
                            data.subNav = [];
                        _this.currentNav = data;
                        _this.loadingNav = false;
                        _this.createPreview();
                    });
                });
            };
            NavConfigurationController.prototype.getAvailableNavs = function () {
                var _this = this;
                this.userService.getAvailableNavigations().then(function (data) {
                    _this.navs = data;
                    for (var i = 0; i < _this.navs.length; i++)
                        if (_this.navs[i].isFix)
                            _this.navs[i].groupName = _this.lng.translate(20000226, "Fix");
                        else
                            _this.navs[i].groupName = _this.lng.translate(20000227, "Editierbar");
                    _this.navsMap = _this.navs.map(function (x) { return ({ text: x.caption, value: x.id, group: x.groupName }); });
                });
            };
            NavConfigurationController.prototype.createNewNav = function () {
                var _this = this;
                this.loading = true;
                this.userService.postNewNavigation({ caption: this.newNavName, mainNav: [], subNav: [] }).then(function (data) {
                    $('#createNewNavModal').modal('hide');
                    _this.getAvailableNavs();
                    _this.selectedNavId = data.createdObjectId;
                    _this.loadNav();
                }).finally(function () {
                    _this.loading = false;
                });
            };
            NavConfigurationController.prototype.copyNav = function () {
                var _this = this;
                this.loading = true;
                this.userService.postNewNavigation({ caption: this.newNavName, mainNav: this.currentNav.mainNav, subNav: this.currentNav.subNav }).then(function (data) {
                    $('#copyNavModal').modal('hide');
                    _this.getAvailableNavs();
                    _this.selectedNavId = data.createdObjectId;
                    _this.loadNav();
                }).finally(function () {
                    _this.loading = false;
                });
            };
            NavConfigurationController.prototype.saveNav = function () {
                var _this = this;
                if (this.currentNav.isFix) {
                    return;
                }
                //fix first level color
                for (var i = 0; i < this.currentNav.mainNav.length; i++)
                    if (this.currentNav.mainNav[i].type === 0)
                        this.currentNav.mainNav[i].color = "login";
                console.log("saving", this.selectedNavId, this.currentNav);
                this.isSavingNav = true;
                this.userService.putNavigation(this.selectedNavId, { mainNav: this.currentNav.mainNav, subNav: this.currentNav.subNav }).then(function (data) {
                    console.log("updated", data);
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.isSavingNav = false;
                });
            };
            NavConfigurationController.prototype.deleteNav = function () {
                var _this = this;
                this.loading = true;
                this.userService.deleteNavigation(this.selectedNavId).then(function (data) {
                    console.log("deleted", data);
                    _this.getAvailableNavs();
                    _this.userService.getUserSettings(["NAVIGATION.WEB"]).then(function (data) {
                        _this.selectedNavId = _this.getSettingValue("NAVIGATION.WEB", QMC.Common.Constants.DEFAULT_NAV_ID, data);
                        _this.loadNav();
                        _this.loading = false;
                    }).finally(function () {
                        _this.loading = false;
                    });
                });
            };
            NavConfigurationController.prototype.setNav = function () {
                var _this = this;
                var settings = {
                    settings: [{ key: "NAVIGATION.WEB", value: this.selectedNavId }]
                };
                if (!this.currentNav.isFix) {
                    this.saveNav();
                }
                this.loadingNav = true;
                this.userService.setUserSettings(settings).then(function (data) {
                    _this.reloadNav();
                });
            };
            NavConfigurationController.prototype.reloadNav = function () {
                var _this = this;
                if (this.isSavingNav)
                    setTimeout(function () { _this.reloadNav(); }, 250);
                else {
                    this.userService.getNavigation(this.selectedNavId).then(function (data) {
                        _this.loadingNav = false;
                        window.createNav(data);
                        window.localStorage.setItem("NAVIGATION", JSON.stringify(data));
                        setTimeout(function () {
                            $("#side-menu").metisMenu('dispose');
                            $('#side-menu').metisMenu();
                        }, 250);
                    });
                }
            };
            NavConfigurationController = __decorate([
                QMC.Controller('QMC.Home', 'NavConfigurationController'),
                QMC.Inject('$qui', '$scope', '$state', 'UserService', 'QmcLanguageService', '$timeout')
            ], NavConfigurationController);
            return NavConfigurationController;
        }());
        Home.NavConfigurationController = NavConfigurationController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var UserService = /** @class */ (function (_super) {
            __extends(UserService, _super);
            function UserService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            UserService.prototype.putNewPassword = function (currentPassword, newPassword) {
                var data = {
                    id: null,
                    objectId: null,
                    NewPassword: newPassword,
                    CurrentPassword: currentPassword
                };
                return _super.prototype.put.call(this, '/User/Password', data).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getCheckPasswordRules = function (newPassword) {
                return _super.prototype.post.call(this, '/User/CheckPasswordRules/', { Password: newPassword }).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getVersionInfo = function () {
                return _super.prototype.get.call(this, '/Info/build/version').then(function (info) { return info; });
            };
            UserService.prototype.deleteSession = function () {
                return _super.prototype.delete.call(this, '/session').then(function (info) { return info; });
            };
            UserService.prototype.updateSession = function () {
                return _super.prototype.put.call(this, '/session/qmc', null).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getUserUpdates = function () {
                return _super.prototype.get.call(this, '/session/UserUpdates').then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getUserSettings = function (keys, webvalue) {
                if (webvalue === void 0) { webvalue = true; }
                return this.get('/Settings', { keys: keys, webvalue: webvalue, global: false }, function (data) {
                    return data;
                });
            };
            UserService.prototype.getGlobalSettings = function (keys, webvalue) {
                if (webvalue === void 0) { webvalue = true; }
                return this.get('/Settings', { keys: keys, webvalue: webvalue, global: true }, function (data) {
                    return data;
                });
            };
            UserService.prototype.setUserSettings = function (data, webValue) {
                if (webValue === void 0) { webValue = true; }
                return this.putParameter('/Settings', { webValue: webValue, global: false }, data).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.setGlobalSettings = function (data, webValue) {
                if (webValue === void 0) { webValue = true; }
                return this.putParameter('/Settings', { webValue: webValue, global: true }, data).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getStates = function () {
                return _super.prototype.get.call(this, '/States', {}).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getFederalStates = function (stateId) {
                return _super.prototype.get.call(this, '/FederalStates/' + stateId, {}).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getFederalStateAssignments = function (isHoliday) {
                return _super.prototype.get.call(this, '/FederalStateAssignment', { isHoliday: isHoliday }).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.putFederalStateAssignments = function (list) {
                return _super.prototype.put.call(this, '/FederalStateAssignment', list).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.getSettingWvModel = function () {
                return _super.prototype.getItem.call(this, '/Settings/WvModel', {}, function (data) {
                    return data;
                });
            };
            // NAVIGATION
            UserService.prototype.getAvailableNavigations = function () {
                return _super.prototype.get.call(this, '/Navigation/List', {}, function (data) {
                    return data;
                });
            };
            UserService.prototype.getNavigation = function (id) {
                if (id === void 0) { id = null; }
                return _super.prototype.getItem.call(this, '/Navigation', { navId: id }, function (data) {
                    return data;
                });
            };
            UserService.prototype.getNavigationItems = function () {
                return _super.prototype.get.call(this, '/Navigation/Item', {}, function (data) {
                    return data;
                });
            };
            UserService.prototype.postNewNavigation = function (data) {
                return _super.prototype.post.call(this, '/Navigation', data).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.putNavigation = function (id, data) {
                return _super.prototype.put.call(this, '/Navigation/' + id, data).then(function (data) {
                    return data;
                });
            };
            UserService.prototype.deleteNavigation = function (id) {
                return _super.prototype.delete.call(this, '/Navigation/' + id).then(function (data) {
                    return data;
                });
            };
            //SETTINGS
            UserService.prototype.getCoverReportTemplates = function (objectType) {
                return _super.prototype.get.call(this, '/Reporting/Template/CoverReports/' + objectType, {}, function (data) {
                    return data;
                });
            };
            UserService.prototype.getElaborativeWarningWv = function () {
                return _super.prototype.getItem.call(this, '/elaborativeWarning', null, function (data) { return data; });
            };
            //ActionLog
            UserService.prototype.getActionLogEntries = function () {
                return _super.prototype.get.call(this, '/ActionLog', { dbConnectionString: angular.element('#session').data('db-connection') }, function (data) {
                    return data;
                });
            };
            UserService.prototype.postActionLogEntry = function (data) {
                return _super.prototype.post.call(this, '/ActionLog?dbConnectionString=' + angular.element('#session').data('db-connection'), data).then(function (data) {
                    return data;
                });
            };
            //Survey
            UserService.prototype.getSurvey = function () {
                return _super.prototype.getItem.call(this, '/User/Survey').then(function (data) { return data; });
            };
            UserService.prototype.dismissSurvey = function (id, performed) {
                return _super.prototype.put.call(this, '/User/Survey/Dismiss/' + id, { performed: performed }).then(function (data) { return data; });
            };
            UserService.$inject = ['$http', '$q'];
            UserService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Home', 'UserService')
            ], UserService);
            return UserService;
        }(QMC.Common.BaseService));
        Home.UserService = UserService;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
(function () {
    angular
        .module('QMC.Home')
        .service('UserService', QMC.Home.UserService);
})();
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var ChangePasswordController = /** @class */ (function () {
            function ChangePasswordController($qui, userService, lng) {
                this.$qui = $qui;
                this.userService = userService;
                this.lng = lng;
                this.loading = false;
                this.mustChangePassword = this.getParameterByName("mustChangePassword") === "true";
                this.changePasswordErrorMessage = this.getParameterByName("errorMessage");
                if (this.mustChangePassword) {
                    $("#qmw-top-nav").hide();
                    $("#qmc-side-nav").hide();
                    $("#nav-toggle").hide();
                }
                $qui.init('einstellungen', function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
            }
            ChangePasswordController.prototype.getParameterByName = function (name) {
                var url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
                if (!results)
                    return null;
                if (!results[2])
                    return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            };
            ChangePasswordController.prototype.changePassword = function () {
                var _this = this;
                this.msg = "";
                if (this.newPassword !== this.checkPassword) {
                    this.error = true;
                    this.success = false;
                    this.msg = this.lng.translate(21003039, 'Die Kennwörter stimmen nicht überein.');
                    return;
                }
                this.userService.getCheckPasswordRules(this.newPassword).then(function (data) {
                    if (data.error) {
                        _this.error = true;
                        _this.success = false;
                        data.errorList.map(function (errorListItem) {
                            if (_this.msg.length > 0) {
                                _this.msg += '\r\n';
                            }
                            _this.msg += errorListItem;
                        });
                        return;
                    }
                    else {
                        _this.loading = true;
                        _this.userService.putNewPassword(_this.password, _this.newPassword).then(function (data) {
                            _this.error = false;
                            _this.success = true;
                            _this.msg = _this.lng.translate(20013002, 'Das Kennwort wurde erfolgreich geändert.');
                            _this.password = "";
                            _this.newPassword = "";
                            _this.checkPassword = "";
                            if (_this.mustChangePassword) {
                                document.getElementById('backButton').click();
                            }
                            _this.loading = false;
                        }).catch(function (data) {
                            if (data.hasOwnProperty('data'))
                                data = data.data;
                            console.log(data);
                            _this.msg = "";
                            if (data.hasOwnProperty('fieldErrors')) {
                                _this.error = true;
                                _this.success = false;
                                if (data.fieldErrors.hasOwnProperty('currentPassword')) {
                                    data.fieldErrors.currentPassword.map(function (fieldError) { return _this.msg += fieldError + " "; });
                                }
                                if (data.fieldErrors.hasOwnProperty('newPassword')) {
                                    data.fieldErrors.newPassword.map(function (fieldError) { return _this.msg += fieldError + " "; });
                                }
                            }
                            else {
                                _this.msg = _this.lng.translate(20002047, "Ein unerwarteter Fehler ist aufgetreten");
                            }
                            _this.loading = false;
                        });
                    }
                });
            };
            ChangePasswordController = __decorate([
                QMC.Controller('QMC.Home', 'ChangePasswordController'),
                QMC.Inject('$qui', 'UserService', 'QmcLanguageService')
            ], ChangePasswordController);
            return ChangePasswordController;
        }());
        Home.ChangePasswordController = ChangePasswordController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var UserSettingsController = /** @class */ (function () {
            /////////////////////////// Constructor //////////////////////////
            function UserSettingsController($qui, $scope, $state, userService, lng, permissionService, terminService) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.terminService = terminService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.loading = false;
                this.globalPermission = false;
                this.planedRawDays = QMC.Common.UserSettingConstantsAndDefaults.PLANEDRAWDAYS;
                this.planedDaysFuture = QMC.Common.UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE;
                this.showDateToFLS = QMC.Common.UserSettingConstantsAndDefaults.SHOWDATETOFLS;
                this.showDateToAZN = QMC.Common.UserSettingConstantsAndDefaults.SHOWDATETOAZN;
                this.showMonthFilterFls = QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS;
                this.signatureHideReports = QMC.Common.UserSettingConstantsAndDefaults.SIGNATUREHIDEREPORTS;
                this.flsWeekplanningShowHoliday = QMC.Common.UserSettingConstantsAndDefaults.FLSWEEKPLANNERSHOWHOLIDAY;
                this.flsWeekplanningShowVacation = true;
                this.flsWeekplanningShowPublicHoliday = true;
                this.weekPlannerEventLength = 60;
                this.weekplannerShowUnplannableCases = false;
                this.tasksFinishedPast = QMC.Common.UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS;
                this.landingPage = QMC.Common.UserSettingConstantsAndDefaults.LANDINGPAGE;
                this.flsSummaryFormatted = true;
                this.shouldLoadTableData = QMC.Common.UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA;
                this.showTimeInTable = QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL;
                this.askDroppedService = QMC.Common.UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE;
                this.dontShowIndirectHours = false;
                this.flsDocuSummaryEntrys = 0;
                //private accountingBookGenerateNumber = false;
                //private accountingBookGenerateNumberOrga = false;
                this.clientCoverTemplate = QMC.Common.Constants.GUID_EMPTY;
                this.getReweNumber = false;
                this.flsCaseFilterWithDirectCarerAllocation = true;
                this.AppointmentAddCalendarOnlyUsersEmployee = false;
                this.AppointmentAddCalendarOnlyUsersClient = false;
                this.AppointmentAddCalendarOnlyUsersAuthority = false;
                this.appointmentWidget = {
                    active: true,
                    orga: false,
                    subOrga: true,
                    endOfWeek: true,
                    daysToFuture: -1,
                    daysToPast: 0,
                };
                this.showNewsFeed = true;
                this.logoReroute = false;
                this.birthday = {
                    active: false,
                    daysToFuture: 7,
                    daysToPast: 0,
                    clients: true,
                    employees: true,
                    orga: QMC.Common.Constants.GUID_EMPTY,
                    subOrga: false
                };
                this.away = {
                    active: false,
                    daysToFuture: 7,
                    daysToPast: 0,
                    subOrga: true,
                    holiday: true,
                    disease: true
                };
                this.flsDocuSummaryPageSize = 30;
                this.daysInPast = QMC.Common.UserSettingConstantsAndDefaults.DAYSINPAST;
                this.showOnlyUnfetched = QMC.Common.UserSettingConstantsAndDefaults.SHOWONLYUNFETCHED;
                this.calendarSlotSize = 30;
                this.activateHumanize = true;
                this.humanizeHours = 24;
                this.appStates = [];
                this.institutes = [];
                this.filterText = '';
                this.federalStateList = [];
                this.federalStateAssignmentList = [];
                this.federalStateAssignmentListChanges = [];
                this.clientCoverReportTemplates = [];
                //get values from api
                this.getValues();
                this.loadingPermission = true;
                permissionService.getPermissionsByObjectTypes([870001]).then(function (data) {
                    _this.globalPermission = data[0].moduleAccess;
                    _this.loadingPermission = false;
                });
                $qui.init("einstellungen", function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    _this.events();
                });
                this.getLandingPages();
                this.getStates();
                this.getWv();
                this.getClientCoverReportTemplates();
                this.getInstitutes();
            }
            UserSettingsController.prototype.isAllowed = function (permissions, type) {
                for (var _i = 0, permissions_1 = permissions; _i < permissions_1.length; _i++) {
                    var perm = permissions_1[_i];
                    if (perm.objectType === type && perm.moduleAccess)
                        return true;
                }
                return false;
            };
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            UserSettingsController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.planedRawDays', function () {
                    if (_this.planedRawDays < -1)
                        _this.planedRawDays = -1;
                    if (_this.planedRawDays > 365)
                        _this.planedRawDays = 365;
                });
                this.$scope.$watch('vm.planedDaysFuture', function () {
                    if (_this.planedDaysFuture < -1)
                        _this.planedDaysFuture = -1;
                    if (_this.planedDaysFuture > 365)
                        _this.planedDaysFuture = 365;
                });
                this.$scope.$watch('vm.tasksFinishedPast', function () {
                    if (_this.tasksFinishedPast < 0)
                        _this.tasksFinishedPast = 0;
                    if (_this.tasksFinishedPast > 365)
                        _this.tasksFinishedPast = 365;
                });
            };
            //////////////////////// SERVICEFUNCTION /////////////////////////
            UserSettingsController.prototype.getValue = function (key) {
                return $.grep(this.settings, function (e) { return e.key === key; })[0].value;
            };
            UserSettingsController.prototype.getValueWin = function (key) {
                return $.grep(this.settingsWin, function (e) { return e.key === key; })[0].value;
            };
            UserSettingsController.prototype.setValue = function (key, value) {
                $.grep(this.settings, function (e) { return e.key === key; })[0].value = value;
            };
            UserSettingsController.prototype.setValueWin = function (key, value) {
                $.grep(this.settingsWin, function (e) { return e.key === key; })[0].value = value;
            };
            UserSettingsController.prototype.convertToBool = function (input) {
                input = input.toLowerCase();
                return input === "true";
            };
            UserSettingsController.prototype.convertToInt = function (input, dval) {
                var val = parseInt(input);
                return !val || isNaN(val) ? dval : val;
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            UserSettingsController.prototype.getValues = function () {
                var _this = this;
                this.loading = true;
                var keys = [];
                keys.push("AZN.SHOWDATETO");
                keys.push("FLS.PLANEDRAWDAYS");
                keys.push("FLS.PLANEDDAYSFUTURE");
                keys.push("FLS.SIGNATURE.HIDEREPORTS");
                keys.push("FLS.SHOWDATETO");
                keys.push("FLS.SHOWMONTHFILTER");
                keys.push("FLS.WEEKPLANNER.SHOWHOLIDAY");
                keys.push("FLS.WEEKPLANNER.SHOWVACATION");
                keys.push("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY");
                keys.push("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH");
                keys.push("WEEKPLANNER.SHOWUNPLANNABLECASES");
                keys.push("TASK.FINISHEDTASKSDAYS");
                keys.push("LANDINGPAGE");
                keys.push("FLS.SUMMARY.FORMATTED");
                keys.push("GLOBAL.SHOULDLOADTABLEDATA");
                keys.push("SHOWTIMEINSTEADOFDECIMAL");
                keys.push("ROSTER.ASKDROPPEDSERVICE");
                keys.push("FLS.CONTINGENT.DONTSHOWINDRECT");
                keys.push("FLS.DOCUSUMMARYITEMS");
                keys.push("FLS.SUMMARY.PAGESIZE");
                keys.push("FLS.CASE.FILTERWITHDIRECTALLOCATION");
                keys.push("NEWSFEED.IGNORE");
                keys.push("FLS.WEEKPLANNER_ONLY_CURRENT_CASES");
                keys.push("LANDINGPAGE.LOGO");
                keys.push("APPOINTMENT.WIDGET.ACTIVE");
                keys.push("APPOINTMENT.WIDGET.ORGA");
                keys.push("APPOINTMENT.WIDGET.SUBORGA");
                keys.push("APPOINTMENT.WIDGET.DAYSTOFUTURE");
                keys.push("APPOINTMENT.WIDGET.DAYSTOPAST");
                keys.push("BIRTHDAY.WIDGET.ACTIVE");
                keys.push("BIRTHDAY.WIDGET.DAYSTOFUTURE");
                keys.push("BIRTHDAY.WIDGET.DAYSTOPAST");
                keys.push("BIRTHDAY.WIDGET.CLIENTS");
                keys.push("BIRTHDAY.WIDGET.EMPLOYEES");
                keys.push("BIRTHDAY.WIDGET.ORGA");
                keys.push("BIRTHDAY.WIDGET.SUBORGA");
                keys.push("AWAY.WIDGET.ACTIVE");
                keys.push("AWAY.WIDGET.DAYSTOFUTURE");
                keys.push("AWAY.WIDGET.DAYSTOPAST");
                keys.push("AWAY.WIDGET.SUBORGA");
                keys.push("AWAY.WIDGET.HOLIDAY");
                keys.push("AWAY.WIDGET.DISEASE");
                keys.push("CALENDAR.SLOTDURATION");
                keys.push("HUMANIZETIME");
                var keysWin = [];
                keysWin.push("FLS.DEFAULTCARETYPE");
                keysWin.push("FLS.DEFAULTCONTACTTYPE");
                keysWin.push("FLS.DEFAULTACTIVITYTYPE");
                //keysWin.push("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT");
                //keysWin.push("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA");
                keysWin.push("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED");
                keysWin.push("DLGREPORTINGSERVERJOBS.DAYSINPAST");
                keysWin.push("FRADECKBLATT.140000.REPORTID");
                keysWin.push("KASSENBUCH.ShowFiBuDataInSearchDialog");
                keysWin.push("TERMINPLAN.ONLYUSERS.120000");
                keysWin.push("TERMINPLAN.ONLYUSERS.140000");
                keysWin.push("TERMINPLAN.ONLYUSERS.180000");
                this.userService.getUserSettings(keys).then(function (data) {
                    _this.settings = data;
                    _this.showDateToAZN = _this.getValue("AZN.SHOWDATETO") === "" ? _this.showDateToAZN : _this.convertToBool(_this.getValue("AZN.SHOWDATETO"));
                    _this.planedRawDays = _this.getValue("FLS.PLANEDRAWDAYS") === "" ? _this.planedRawDays : parseFloat(_this.getValue("FLS.PLANEDRAWDAYS"));
                    _this.planedDaysFuture = _this.getValue("FLS.PLANEDDAYSFUTURE") === "" ? _this.planedDaysFuture : parseFloat(_this.getValue("FLS.PLANEDDAYSFUTURE"));
                    _this.signatureHideReports = _this.getValue("FLS.SIGNATURE.HIDEREPORTS") === "" ? _this.signatureHideReports : _this.convertToBool(_this.getValue("FLS.SIGNATURE.HIDEREPORTS"));
                    _this.showDateToFLS = _this.getValue("FLS.SHOWDATETO") === "" ? _this.showDateToFLS : _this.convertToBool(_this.getValue("FLS.SHOWDATETO"));
                    _this.showMonthFilterFls = _this.getValue("FLS.SHOWMONTHFILTER") === "" ? _this.showMonthFilterFls : _this.convertToBool(_this.getValue("FLS.SHOWMONTHFILTER"));
                    _this.flsWeekplanningShowHoliday = _this.getValue("FLS.WEEKPLANNER.SHOWHOLIDAY") === "" ? _this.flsWeekplanningShowHoliday : _this.convertToBool(_this.getValue("FLS.WEEKPLANNER.SHOWHOLIDAY"));
                    _this.flsWeekplanningShowVacation = _this.getValue("FLS.WEEKPLANNER.SHOWVACATION") === "" ? _this.flsWeekplanningShowVacation : _this.convertToBool(_this.getValue("FLS.WEEKPLANNER.SHOWVACATION"));
                    _this.flsWeekplanningShowPublicHoliday = _this.getValue("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY") === "" ? _this.flsWeekplanningShowPublicHoliday : _this.convertToBool(_this.getValue("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY"));
                    _this.weekPlannerEventLength = _this.getValue("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH") === "" ? _this.weekPlannerEventLength : parseInt(_this.getValue("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH"));
                    _this.weekplannerShowUnplannableCases = _this.getValue("WEEKPLANNER.SHOWUNPLANNABLECASES") === "" ? _this.weekplannerShowUnplannableCases : _this.convertToBool(_this.getValue("WEEKPLANNER.SHOWUNPLANNABLECASES"));
                    _this.tasksFinishedPast = _this.getValue("TASK.FINISHEDTASKSDAYS") === "" ? _this.tasksFinishedPast : parseFloat(_this.getValue("TASK.FINISHEDTASKSDAYS"));
                    _this.landingPage = _this.getValue("LANDINGPAGE");
                    _this.flsSummaryFormatted = _this.getValue("FLS.SUMMARY.FORMATTED") === "" ? _this.flsSummaryFormatted : _this.convertToBool(_this.getValue("FLS.SUMMARY.FORMATTED"));
                    _this.shouldLoadTableData = _this.getValue("GLOBAL.SHOULDLOADTABLEDATA") === "" ? _this.shouldLoadTableData : _this.convertToBool(_this.getValue("GLOBAL.SHOULDLOADTABLEDATA"));
                    _this.showTimeInTable = _this.getValue("SHOWTIMEINSTEADOFDECIMAL") === "" ? _this.showTimeInTable : _this.convertToBool(_this.getValue("SHOWTIMEINSTEADOFDECIMAL"));
                    _this.askDroppedService = _this.getValue("ROSTER.ASKDROPPEDSERVICE") === "" ? _this.askDroppedService : _this.convertToBool(_this.getValue("ROSTER.ASKDROPPEDSERVICE"));
                    _this.dontShowIndirectHours = _this.getValue("FLS.CONTINGENT.DONTSHOWINDRECT") === "" ? _this.dontShowIndirectHours : _this.convertToBool(_this.getValue("FLS.CONTINGENT.DONTSHOWINDRECT"));
                    _this.flsDocuSummaryEntrys = _this.getValue("FLS.DOCUSUMMARYITEMS") === "" ? _this.flsDocuSummaryEntrys : parseInt(_this.getValue("FLS.DOCUSUMMARYITEMS"));
                    _this.flsDocuSummaryPageSize = _this.getValue("FLS.SUMMARY.PAGESIZE") === "" ? _this.flsDocuSummaryPageSize : parseInt(_this.getValue("FLS.SUMMARY.PAGESIZE"));
                    _this.flsCaseFilterWithDirectCarerAllocation = _this.getValue("FLS.CASE.FILTERWITHDIRECTALLOCATION") === "" ? _this.flsCaseFilterWithDirectCarerAllocation : _this.convertToBool(_this.getValue("FLS.CASE.FILTERWITHDIRECTALLOCATION"));
                    _this.showNewsFeed = _this.getValue("NEWSFEED.IGNORE") === "" ? _this.showNewsFeed : !_this.convertToBool(_this.getValue("NEWSFEED.IGNORE"));
                    _this.logoReroute = _this.getValue("LANDINGPAGE.LOGO") === "" ? _this.logoReroute : _this.convertToBool(_this.getValue("LANDINGPAGE.LOGO"));
                    _this.appointmentWidget.active = _this.getValue("APPOINTMENT.WIDGET.ACTIVE") === "" ? _this.appointmentWidget.active : _this.convertToBool(_this.getValue("APPOINTMENT.WIDGET.ACTIVE"));
                    _this.appointmentWidget.orga = _this.getValue("APPOINTMENT.WIDGET.ORGA") === "" ? _this.appointmentWidget.orga : _this.convertToBool(_this.getValue("APPOINTMENT.WIDGET.ORGA"));
                    _this.appointmentWidget.subOrga = _this.getValue("APPOINTMENT.WIDGET.SUBORGA") === "" ? _this.appointmentWidget.subOrga : _this.convertToBool(_this.getValue("APPOINTMENT.WIDGET.SUBORGA"));
                    _this.appointmentWidget.daysToFuture = _this.convertToInt(_this.getValue("APPOINTMENT.WIDGET.DAYSTOFUTURE"), _this.appointmentWidget.daysToFuture);
                    _this.appointmentWidget.daysToPast = _this.convertToInt(_this.getValue("APPOINTMENT.WIDGET.DAYSTOPAST"), _this.appointmentWidget.daysToPast);
                    _this.appointmentWidget.endOfWeek = _this.appointmentWidget.daysToFuture < 0;
                    if (_this.appointmentWidget.endOfWeek)
                        _this.appointmentWidget.daysToFuture = 7;
                    _this.birthday.active = _this.getValue("BIRTHDAY.WIDGET.ACTIVE") === "" ? _this.birthday.active : _this.convertToBool(_this.getValue("BIRTHDAY.WIDGET.ACTIVE"));
                    _this.birthday.daysToFuture = _this.getValue("BIRTHDAY.WIDGET.DAYSTOFUTURE") === "" ? _this.birthday.daysToFuture : parseInt(_this.getValue("BIRTHDAY.WIDGET.DAYSTOFUTURE"));
                    _this.birthday.daysToPast = _this.getValue("BIRTHDAY.WIDGET.DAYSTOPAST") === "" ? _this.birthday.daysToPast : parseInt(_this.getValue("BIRTHDAY.WIDGET.DAYSTOPAST"));
                    _this.birthday.clients = _this.getValue("BIRTHDAY.WIDGET.CLIENTS") === "" ? _this.birthday.clients : _this.convertToBool(_this.getValue("BIRTHDAY.WIDGET.CLIENTS"));
                    _this.birthday.employees = _this.getValue("BIRTHDAY.WIDGET.EMPLOYEES") === "" ? _this.birthday.employees : _this.convertToBool(_this.getValue("BIRTHDAY.WIDGET.EMPLOYEES"));
                    _this.birthday.orga = _this.getValue("BIRTHDAY.WIDGET.ORGA") === "" ? _this.birthday.orga : _this.getValue("BIRTHDAY.WIDGET.ORGA");
                    _this.birthday.subOrga = _this.getValue("BIRTHDAY.WIDGET.SUBORGA") === "" ? _this.birthday.subOrga : _this.convertToBool(_this.getValue("BIRTHDAY.WIDGET.SUBORGA"));
                    _this.away.active = _this.getValue("AWAY.WIDGET.ACTIVE") === "" ? _this.away.active : _this.convertToBool(_this.getValue("AWAY.WIDGET.ACTIVE"));
                    _this.away.daysToFuture = _this.getValue("AWAY.WIDGET.DAYSTOFUTURE") === "" ? _this.away.daysToFuture : parseInt(_this.getValue("AWAY.WIDGET.DAYSTOFUTURE"));
                    _this.away.daysToPast = _this.getValue("AWAY.WIDGET.DAYSTOPAST") === "" ? _this.away.daysToPast : parseInt(_this.getValue("AWAY.WIDGET.DAYSTOPAST"));
                    _this.away.subOrga = _this.getValue("AWAY.WIDGET.SUBORGA") === "" ? _this.away.subOrga : _this.convertToBool(_this.getValue("AWAY.WIDGET.SUBORGA"));
                    _this.away.holiday = _this.getValue("AWAY.WIDGET.HOLIDAY") === "" ? _this.away.holiday : _this.convertToBool(_this.getValue("AWAY.WIDGET.HOLIDAY"));
                    _this.away.disease = _this.getValue("AWAY.WIDGET.DISEASE") === "" ? _this.away.disease : _this.convertToBool(_this.getValue("AWAY.WIDGET.DISEASE"));
                    _this.calendarSlotSize = _this.getValue("CALENDAR.SLOTDURATION") === "" ? _this.calendarSlotSize : parseInt(_this.getValue("CALENDAR.SLOTDURATION"));
                    _this.humanizeHours = _this.getValue("HUMANIZETIME") === "" ? _this.humanizeHours : parseInt(_this.getValue("HUMANIZETIME"));
                    _this.activateHumanize = _this.humanizeHours >= 0;
                    if (_this.humanizeHours < 0)
                        _this.humanizeHours = 24;
                    _this.userService.getUserSettings(keysWin, false).then(function (dataW) {
                        _this.settingsWin = dataW;
                        _this.flsDefaultCareType = _this.getValueWin("FLS.DEFAULTCARETYPE");
                        _this.flsDefaultContactType = _this.getValueWin("FLS.DEFAULTCONTACTTYPE");
                        _this.flsDefaultActivityType = _this.getValueWin("FLS.DEFAULTACTIVITYTYPE");
                        //this.accountingBookGenerateNumber = this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT") === "" ? this.accountingBookGenerateNumber : this.convertToBool(this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT"));
                        //this.accountingBookGenerateNumberOrga = this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA") === "" ? this.accountingBookGenerateNumberOrga : this.convertToBool(this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA"));
                        _this.daysInPast = _this.getValueWin("DLGREPORTINGSERVERJOBS.DAYSINPAST") === "" ? _this.daysInPast : parseInt(_this.getValueWin("DLGREPORTINGSERVERJOBS.DAYSINPAST"));
                        _this.showOnlyUnfetched = _this.getValueWin("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED") === "" ? _this.showOnlyUnfetched : _this.convertToBool(_this.getValueWin("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED"));
                        _this.clientCoverTemplate = _this.getValueWin('FRADECKBLATT.140000.REPORTID') === '' ? _this.clientCoverTemplate : _this.getValueWin('FRADECKBLATT.140000.REPORTID');
                        _this.getReweNumber = _this.getValueWin("KASSENBUCH.ShowFiBuDataInSearchDialog") === "" ? _this.getReweNumber : _this.convertToBool(_this.getValueWin("KASSENBUCH.ShowFiBuDataInSearchDialog"));
                        _this.AppointmentAddCalendarOnlyUsersEmployee = _this.getValueWin("TERMINPLAN.ONLYUSERS.120000") === "" ? _this.AppointmentAddCalendarOnlyUsersEmployee : _this.convertToBool(_this.getValueWin("TERMINPLAN.ONLYUSERS.120000"));
                        _this.AppointmentAddCalendarOnlyUsersClient = _this.getValueWin("TERMINPLAN.ONLYUSERS.140000") === "" ? _this.AppointmentAddCalendarOnlyUsersClient : _this.convertToBool(_this.getValueWin("TERMINPLAN.ONLYUSERS.140000"));
                        _this.AppointmentAddCalendarOnlyUsersAuthority = _this.getValueWin("TERMINPLAN.ONLYUSERS.180000") === "" ? _this.AppointmentAddCalendarOnlyUsersAuthority : _this.convertToBool(_this.getValueWin("TERMINPLAN.ONLYUSERS.180000"));
                        _this.loading = false;
                    });
                });
            };
            UserSettingsController.prototype.saveSettings = function () {
                var _this = this;
                var _a, _b, _c;
                sessionStorage.removeItem('Setting.AutoLoadTables');
                // Format values if needed
                this.planedRawDays = Math.round(this.planedRawDays);
                this.loading = true;
                this.setValue("AZN.SHOWDATETO", String(this.showDateToAZN));
                this.setValue("FLS.PLANEDRAWDAYS", String(this.planedRawDays));
                this.setValue("FLS.PLANEDDAYSFUTURE", String(this.planedDaysFuture));
                this.setValue("FLS.SHOWDATETO", String(this.showDateToFLS));
                this.setValue("FLS.SHOWMONTHFILTER", String(this.showMonthFilterFls));
                this.setValue("FLS.SIGNATURE.HIDEREPORTS", String(this.signatureHideReports));
                this.setValue("FLS.WEEKPLANNER.SHOWHOLIDAY", String(this.flsWeekplanningShowHoliday));
                this.setValue("FLS.WEEKPLANNER.SHOWVACATION", String(this.flsWeekplanningShowVacation));
                this.setValue("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY", String(this.flsWeekplanningShowPublicHoliday));
                this.setValue("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH", String(this.weekPlannerEventLength));
                this.setValue("WEEKPLANNER.SHOWUNPLANNABLECASES", String(this.weekplannerShowUnplannableCases));
                this.setValue("TASK.FINISHEDTASKSDAYS", String(this.tasksFinishedPast));
                this.setValue("LANDINGPAGE", this.landingPage);
                this.setValue("FLS.SUMMARY.FORMATTED", String(this.flsSummaryFormatted));
                this.setValue("GLOBAL.SHOULDLOADTABLEDATA", String(this.shouldLoadTableData));
                this.setValue("SHOWTIMEINSTEADOFDECIMAL", String(this.showTimeInTable));
                this.setValue("ROSTER.ASKDROPPEDSERVICE", String(this.askDroppedService));
                this.setValue("FLS.CONTINGENT.DONTSHOWINDRECT", String(this.dontShowIndirectHours));
                this.setValue("FLS.DOCUSUMMARYITEMS", String(this.flsDocuSummaryEntrys));
                this.setValue("FLS.SUMMARY.PAGESIZE", String(this.flsDocuSummaryPageSize));
                this.setValue("FLS.CASE.FILTERWITHDIRECTALLOCATION", String(this.flsCaseFilterWithDirectCarerAllocation));
                this.setValue("NEWSFEED.IGNORE", String(!this.showNewsFeed));
                this.setValue("LANDINGPAGE.LOGO", String(this.logoReroute));
                this.setValue("CALENDAR.SLOTDURATION", String(this.calendarSlotSize));
                this.setValue("HUMANIZETIME", this.activateHumanize ? String(this.humanizeHours) : String(-1));
                this.setValue("APPOINTMENT.WIDGET.ACTIVE", String(this.appointmentWidget.active));
                this.setValue("APPOINTMENT.WIDGET.ORGA", String(this.appointmentWidget.orga));
                this.setValue("APPOINTMENT.WIDGET.SUBORGA", String(this.appointmentWidget.subOrga));
                this.setValue("APPOINTMENT.WIDGET.DAYSTOPAST", String(this.appointmentWidget.daysToPast));
                this.setValue("APPOINTMENT.WIDGET.DAYSTOFUTURE", String(this.appointmentWidget.endOfWeek ? -1 : this.appointmentWidget.daysToFuture));
                this.setValue("BIRTHDAY.WIDGET.ACTIVE", String(this.birthday.active));
                this.setValue("BIRTHDAY.WIDGET.DAYSTOFUTURE", String(this.birthday.daysToFuture));
                this.setValue("BIRTHDAY.WIDGET.DAYSTOPAST", String(this.birthday.daysToPast));
                this.setValue("BIRTHDAY.WIDGET.CLIENTS", String(this.birthday.clients));
                this.setValue("BIRTHDAY.WIDGET.EMPLOYEES", String(this.birthday.employees));
                this.setValue("BIRTHDAY.WIDGET.ORGA", String(this.birthday.orga));
                this.setValue("BIRTHDAY.WIDGET.SUBORGA", String(this.birthday.subOrga));
                this.setValue("AWAY.WIDGET.ACTIVE", String(this.away.active));
                this.setValue("AWAY.WIDGET.DAYSTOFUTURE", String(this.away.daysToFuture));
                this.setValue("AWAY.WIDGET.DAYSTOPAST", String(this.away.daysToPast));
                this.setValue("AWAY.WIDGET.SUBORGA", String(this.away.subOrga));
                this.setValue("AWAY.WIDGET.HOLIDAY", String(this.away.holiday));
                this.setValue("AWAY.WIDGET.DISEASE", String(this.away.disease));
                this.setValueWin("FLS.DEFAULTCARETYPE", (_a = this.flsDefaultCareType) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY);
                this.setValueWin("FLS.DEFAULTCONTACTTYPE", (_b = this.flsDefaultContactType) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY);
                this.setValueWin("FLS.DEFAULTACTIVITYTYPE", (_c = this.flsDefaultActivityType) !== null && _c !== void 0 ? _c : QMC.Common.Constants.GUID_EMPTY);
                //this.setValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT", String(this.accountingBookGenerateNumber));
                //this.setValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA", String(this.accountingBookGenerateNumberOrga));
                this.setValueWin("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED", String(this.showOnlyUnfetched));
                this.setValueWin("DLGREPORTINGSERVERJOBS.DAYSINPAST", String(this.daysInPast));
                this.setValueWin("FRADECKBLATT.140000.REPORTID", this.clientCoverTemplate);
                this.setValueWin("KASSENBUCH.ShowFiBuDataInSearchDialog", String(this.getReweNumber));
                this.setValueWin("TERMINPLAN.ONLYUSERS.120000", String(this.AppointmentAddCalendarOnlyUsersEmployee));
                this.setValueWin("TERMINPLAN.ONLYUSERS.140000", String(this.AppointmentAddCalendarOnlyUsersClient));
                this.setValueWin("TERMINPLAN.ONLYUSERS.180000", String(this.AppointmentAddCalendarOnlyUsersAuthority));
                this.userService.setUserSettings({ settings: this.settings }).then(function (data) {
                    _this.userService.setUserSettings({ settings: _this.settingsWin }, false).then(function (data) {
                        sessionStorage.setItem("HUMANIZETIME", String(_this.activateHumanize ? _this.humanizeHours : -1));
                        _this.$qui.notify(_this.$qui.successNote);
                        _this.getValues();
                    });
                });
            };
            UserSettingsController.prototype.getLandingPages = function () {
                var _this = this;
                this.appStates = [];
                this.userService.getNavigationItems().then(function (data) {
                    var objectTypes = [];
                    for (var i = 0; i < data.length; i++) {
                        objectTypes.push(data[i].objectType);
                    }
                    _this.permissionService.getPermissionsByObjectTypes(objectTypes).then(function (pData) {
                        for (var i = 0; i < data.length; i++)
                            if (data[i].objectType === 0 || _this.isAllowed(pData, data[i].objectType)) {
                                _this.appStates.push({
                                    text: _this.lng.translate(data[i].languageTag, data[i].caption),
                                    value: data[i].link
                                });
                            }
                        _this.appStates = _this.appStates.sort(function (a, b) {
                            var textA = a.text.toUpperCase();
                            var textB = b.text.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        _this.appStates.unshift({ text: "", value: "" });
                    });
                });
            };
            UserSettingsController.prototype.getStates = function () {
                var _this = this;
                this.userService.getStates().then(function (data) {
                    _this.stateList = _this.$qui.selectAutoMap(data, 'id', 'denotation');
                    _this.selectedState = 'e8dfa43c-c3d4-408d-87d8-7bf9ccdb0ab7';
                    _this.getFederalStates(_this.selectedState);
                    _this.$scope.$watch('vm.selectedState', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        _this.getFederalStates(_this.selectedState);
                    });
                });
            };
            UserSettingsController.prototype.getInstitutes = function () {
                var _this = this;
                this.userService.getInstituteList().then(function (data) {
                    _this.institutes = data.map(function (x) { return { text: x.caption, value: x.objectId }; }).sort(function (a, b) { return (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0); });
                    _this.institutes.unshift({ text: _this.lng.translate(20000319, '- Eigene Organization -'), value: '00000000-0000-0000-0000-000000000000' });
                });
            };
            UserSettingsController.prototype.getClientCoverReportTemplates = function (objectType) {
                var _this = this;
                if (objectType === void 0) { objectType = 140000; }
                this.userService.getCoverReportTemplates(objectType).then(function (data) {
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var item = data_1[_i];
                        switch (item.reportType) {
                            case 7000:
                                item.reportType = _this.lng.translate(20015036, 'Vorlage');
                                break;
                            case 3000:
                                item.reportType = _this.lng.translate(20015038, 'Tabellenkalkulation');
                                break;
                            default:
                                item.reportType = '';
                                break;
                        }
                    }
                    _this.clientCoverReportTemplates = data.map(function (x) { return ({ text: x.name, value: x.objectId, group: x.reportType }); });
                    if (_this.clientCoverTemplate === QMC.Common.Constants.GUID_EMPTY)
                        _this.clientCoverTemplate = data[0].objectId;
                });
            };
            UserSettingsController.prototype.getFederalStates = function (selectedState) {
                var _this = this;
                this.userService.getFederalStates(selectedState).then(function (data) {
                    _this.federalStateList = data;
                    _this.getFederalStateAssignments(_this.isHoliday);
                });
            };
            UserSettingsController.prototype.openModal = function (isHoliday) {
                if (isHoliday !== this.isHoliday) {
                    this.isHoliday = isHoliday;
                }
                this.getFederalStateAssignments(this.isHoliday);
            };
            UserSettingsController.prototype.getFederalStateAssignments = function (isHoliday) {
                var _this = this;
                this.userService.getFederalStateAssignments(isHoliday).then(function (assignments) {
                    _this.federalStateAssignmentList = _this.federalStateList.map(function (federalState) {
                        var assignment = assignments.find(function (item) { return item.federalStateId === federalState.id; });
                        return { federalStateId: federalState.id, assignmentId: (assignment !== undefined) ? assignment.id : null, denotation: federalState.denotation, show: (assignment !== undefined), isHoliday: isHoliday };
                    });
                });
            };
            UserSettingsController.prototype.federalStateAssignmentListItemChanged = function (changedItem) {
                this.federalStateAssignmentListChanges.push(changedItem);
            };
            UserSettingsController.prototype.putFederalStateAssignmentList = function () {
                var _this = this;
                $('#selectFederalStateModal').modal('hide');
                this.userService.putFederalStateAssignments(this.federalStateAssignmentListChanges).then(function () {
                    _this.federalStateAssignmentListChanges = [];
                });
                this.federalStateAssignmentListChanges = [];
            };
            UserSettingsController.prototype.getWv = function () {
                var _this = this;
                this.userService.getSettingWvModel().then(function (data) {
                    _this.flsContactTypes = data.flsContactTypeWvModel.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                    _this.flsCareTypes = data.flsCareTypeWvModel.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                    _this.flsActivityTypes = data.flsActivityTypeWvModel.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                });
            };
            UserSettingsController.prototype.resetBrowserCache = function () {
                var temp = localStorage.getItem(QMC.Common.LocalStorageConstants.USER_MODULE_PERMISSIONS);
                localStorage.clear();
                localStorage.setItem(QMC.Common.LocalStorageConstants.USER_MODULE_PERMISSIONS, temp);
                window.location.reload(true);
            };
            UserSettingsController = __decorate([
                QMC.Controller('QMC.Home', 'UserSettingsController'),
                QMC.Inject('$qui', '$scope', '$state', 'UserService', 'QmcLanguageService', 'QmcPermissionService', 'TerminService')
            ], UserSettingsController);
            return UserSettingsController;
        }());
        Home.UserSettingsController = UserSettingsController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var UserGlobalSettingsController = /** @class */ (function () {
            /////////////////////////// Constructor //////////////////////////
            function UserGlobalSettingsController($qui, $scope, userService, lng, permissionService, flsService) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.loading = false;
                this.globalPermission = false;
                this.boolean = true;
                this.signingPersonIsClient = false;
                this.inactivityTime = QMC.Common.UserSettingConstantsAndDefaults.INACTIVITYTIMEOUT;
                this.flsMinutesToSign = QMC.Common.UserSettingConstantsAndDefaults.FLSMINUTESTOSIGN;
                this.landingPage = QMC.Common.UserSettingConstantsAndDefaults.LANDINGPAGE;
                this.shouldLoadTableData = QMC.Common.UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA;
                this.defaultNavId = QMC.Common.UserSettingConstantsAndDefaults.NAVIGATION_DEFAULT_ID;
                this.defaultSigningPersonId = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGPERSON;
                this.defaultSigningReasonId = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGREASON;
                this.defaultSigningReasonText = "";
                this.flsSignatureReasonNotMandatory = false;
                this.blockSignatureModal = false;
                this.daysToHighlightCases = 0;
                this.dontShowIndirectHours = false;
                this.createAdditionalFls = false;
                this.createAdditionalFlsText = "";
                this.flsDocuSummaryEntrys = 0;
                this.flsDistributeHours = QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN;
                this.flsDistributeHoursFix = QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX;
                this.flsResetTimeForManualDuration = QMC.Common.UserSettingConstantsAndDefaults.GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG;
                this.serverJobPollingTimer = QMC.Common.UserSettingConstantsAndDefaults.SERVERJOBTIMERINTERVALLINSEC;
                this.weekplannerShowUnplannableCases = false;
                this.flsWeekplannerIncludeFutureCases = QMC.Common.UserSettingConstantsAndDefaults.FLS_WEEKPLANNER_INCLUDE_FUTURE_CASES;
                this.flsWeekplannerIncludePastCases = false;
                this.dontShowRawDocusIfEmptyIsAllowed = false;
                this.flsCaseFilterWithDirectCarerAllocation = true;
                this.AppointmentAddCalendarOnlyUsersEmployee = false;
                this.AppointmentAddCalendarOnlyUsersClient = false;
                this.AppointmentAddCalendarOnlyUsersAuthority = false;
                this.flsHideQuickDrivingCost = false;
                this.flsAllowEmptyDrivingCost = false;
                this.flsPredfinedTitleMode = '0';
                this.flsPredfinedTitle = '';
                this.logoReroute = false;
                this.rosterShowInactive = false;
                this.inquireStampinOnLogin = QMC.Common.UserSettingConstantsAndDefaults.INQUIRE_STAMPIN_ON_LOGIN;
                this.inquireStampOutOnLogout = QMC.Common.UserSettingConstantsAndDefaults.INQUIRE_STAMPOUT_ON_LOGOUT;
                this.saVaccination = 'impfung; impfen';
                this.saDocVisit = 'arzt; doktor';
                this.saDisease = 'krank; krankheit; grippe; fieber';
                this.saAppointment = 'termin; verabredung; meeting';
                this.saAbsenteeism = 'abwesend; abwesenheit';
                this.saMessage = 'nachricht; mail; meldung';
                this.saTask = 'aufgabe; task';
                this.saDocument = 'dokument';
                this.saAccountingBook = 'kassenbuch';
                this.saContactperson = 'kontakt; kontaktperson';
                this.flsShowManuelTime = true;
                this.richTextImages = {
                    disabled: false,
                    size: 4,
                    height: 1080,
                    width: 1920
                };
                this.appStates = [];
                this.flsTitleSetting = [
                    { text: this.lng.translate(20013150, 'Systemvorgabe'), value: '0' },
                    { text: this.lng.translate(20013151, 'Leer'), value: '1' },
                    { text: this.lng.translate(20013152, 'Eigene Vorgabe'), value: '2' }
                ];
                //get values from api
                this.getValues();
                this.loadingPermission = true;
                permissionService.getPermissionsByObjectType(870000).then(function (data) {
                    _this.globalPermission = data[0].moduleAccess;
                    _this.loadingPermission = false;
                });
                this.userService.getAvailableNavigations().then((function (data) {
                    _this.navigations = data.map(function (obj) { return ({ value: obj.id, text: obj.caption }); });
                }));
                this.flsService.getSignatureWv().then((function (data) {
                    _this.flsSigningPersons = data.signingPersons.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); });
                    _this.flsSigningReasons = data.reasons.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); });
                }));
                $qui.init("einstellungen", function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    _this.events();
                });
                this.getLandingPages();
                this.$scope.$watchCollection('vm.defaultSigningPersonId', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.setSigningPersonSettingVisibility();
                });
                this.setSigningPersonSettingVisibility();
            }
            UserGlobalSettingsController.prototype.setSigningPersonSettingVisibility = function () {
                if (this.defaultSigningPersonId == QMC.Common.Constants.SIGNATURE_SIGNING_PERSON_CLIENT) {
                    this.defaultSigningReasonId = QMC.Common.Constants.GUID_EMPTY;
                    this.defaultSigningReasonText = '';
                    this.signingPersonIsClient = true;
                }
                else
                    this.signingPersonIsClient = false;
            };
            UserGlobalSettingsController.prototype.isAllowed = function (permissions, type) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].objectType === type && permissions[i].moduleAccess)
                        return true;
                }
                return false;
            };
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            UserGlobalSettingsController.prototype.events = function () {
            };
            //////////////////////// SERVICEFUNCTION /////////////////////////
            UserGlobalSettingsController.prototype.getValueGlobal = function (key) {
                return $.grep(this.globalSettings, function (e) { return e.key === key; })[0].value;
            };
            UserGlobalSettingsController.prototype.setValueGlobal = function (key, value) {
                $.grep(this.globalSettings, function (e) { return e.key === key; })[0].value = value;
            };
            UserGlobalSettingsController.prototype.getValueGlobalWin = function (key) {
                return $.grep(this.globalSettingsWin, function (e) { return e.key === key; })[0].value;
            };
            UserGlobalSettingsController.prototype.setValueGlobalWin = function (key, value) {
                $.grep(this.globalSettingsWin, function (e) { return e.key === key; })[0].value = value;
            };
            UserGlobalSettingsController.prototype.convertToBool = function (input) {
                input = input.toLowerCase();
                return input === "true";
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            UserGlobalSettingsController.prototype.getValues = function () {
                var _this = this;
                this.loading = true;
                var keys = [
                    "FLS.MINUTESTOSIGN",
                    "SECURITY.INACTIVITYTIMEOUT",
                    "GLOBAL.LANDINGPAGE",
                    "GLOBAL.SHOULDLOADTABLEDATA",
                    "GLOBAL.NAVIGATION.WEB",
                    "FLS.SIGNATURE.BLOCK",
                    "FLS.CASE.DAYSTOHIGHLIGHT",
                    "FLS.CONTINGENT.DONTSHOWINDRECT",
                    "FLS.ADDITIONAL_TIMELESS_ENTRY",
                    "FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT",
                    "FLS.CASE.FILTERWITHDIRECTALLOCATION",
                    "FLS.DOCUSUMMARYITEMS",
                    "FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED",
                    "FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES",
                    "FLS.WEEKPLANNER_INCLUDE_PAST_CASES",
                    "WEEKPLANNER.SHOWUNPLANNABLECASES",
                    "FLS.HIDE_QUICK_DRIVINGCOST",
                    "TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN",
                    "TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT",
                    "SMARTACTIONS.VACCINATION",
                    "SMARTACTIONS.DOCVISIT",
                    "SMARTACTIONS.DISEASE",
                    "SMARTACTIONS.APPOINTMENT",
                    "SMARTACTIONS.ABSENTEEISM",
                    "SMARTACTIONS.INTERNALMESSAGE",
                    "SMARTACTIONS.TASK",
                    "SMARTACTIONS.DOCUMENT",
                    "SMARTACTIONS.ACCOUNTINGBOOK",
                    "SMARTACTIONS.CONTACTPERSON",
                    "LANDINGPAGE.LOGO",
                    "RICHTEXTIMAGES"
                ];
                var keysWin = [
                    "FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE",
                    "FLS.SIGNATURE.DEFAULTSIGNINGPERSON",
                    "FLS.SIGNATURE.DEFAULTSIGNINGREASON",
                    "FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT",
                    "FLS.SIGNATURE.REASONNOTMANDATORY",
                    "FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN",
                    "FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX",
                    "GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG",
                    "SERVERJOBTIMERINTERVALLINSEC",
                    "TERMINPLAN.ONLYUSERS.GLOBAL.120000",
                    "TERMINPLAN.ONLYUSERS.GLOBAL.140000",
                    "TERMINPLAN.ONLYUSERS.GLOBAL.180000",
                    "FLS.DOKU.BERICHTTITELVORGABE",
                    "FLS.DOKU.BERICHTTITEL",
                    "DIENSTPLAN.SHOWINACTIVEPERSONS",
                    "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"
                ];
                this.userService.getGlobalSettings(keys).then(function (data) {
                    _this.globalSettings = data;
                    _this.flsMinutesToSign = _this.getValueGlobal("FLS.MINUTESTOSIGN") === "" ? _this.flsMinutesToSign : parseFloat(_this.getValueGlobal("FLS.MINUTESTOSIGN"));
                    _this.inactivityTime = _this.getValueGlobal("SECURITY.INACTIVITYTIMEOUT") === "" ? _this.inactivityTime : parseFloat(_this.getValueGlobal("SECURITY.INACTIVITYTIMEOUT"));
                    _this.landingPage = _this.getValueGlobal("GLOBAL.LANDINGPAGE");
                    _this.shouldLoadTableData = _this.getValueGlobal("GLOBAL.SHOULDLOADTABLEDATA") === "" ? _this.shouldLoadTableData : _this.convertToBool(_this.getValueGlobal("GLOBAL.SHOULDLOADTABLEDATA"));
                    _this.defaultNavId = _this.getValueGlobal("GLOBAL.NAVIGATION.WEB") === "" ? _this.defaultNavId : _this.getValueGlobal("GLOBAL.NAVIGATION.WEB");
                    _this.blockSignatureModal = _this.getValueGlobal("FLS.SIGNATURE.BLOCK") === "" ? _this.blockSignatureModal : _this.convertToBool(_this.getValueGlobal("FLS.SIGNATURE.BLOCK"));
                    _this.daysToHighlightCases = _this.getValueGlobal("FLS.CASE.DAYSTOHIGHLIGHT") === "" ? _this.daysToHighlightCases : parseInt(_this.getValueGlobal("FLS.CASE.DAYSTOHIGHLIGHT"));
                    _this.dontShowIndirectHours = _this.getValueGlobal("FLS.CONTINGENT.DONTSHOWINDRECT") === "" ? _this.dontShowIndirectHours : _this.convertToBool(_this.getValueGlobal("FLS.CONTINGENT.DONTSHOWINDRECT"));
                    _this.createAdditionalFls = _this.getValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY") === "" ? _this.dontShowIndirectHours : _this.convertToBool(_this.getValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY"));
                    _this.createAdditionalFlsText = _this.createAdditionalFls ? _this.getValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT") : "";
                    _this.flsDocuSummaryEntrys = _this.getValueGlobal("FLS.DOCUSUMMARYITEMS") === "" ? _this.flsDocuSummaryEntrys : parseInt(_this.getValueGlobal("FLS.DOCUSUMMARYITEMS"));
                    _this.flsWeekplannerIncludeFutureCases = _this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES") === "" ? _this.flsWeekplannerIncludeFutureCases : _this.convertToBool(_this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES"));
                    _this.flsWeekplannerIncludePastCases = _this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_PAST_CASES") === "" ? _this.flsWeekplannerIncludePastCases : _this.convertToBool(_this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_PAST_CASES"));
                    _this.weekplannerShowUnplannableCases = _this.getValueGlobal("WEEKPLANNER.SHOWUNPLANNABLECASES") === "" ? _this.weekplannerShowUnplannableCases : _this.convertToBool(_this.getValueGlobal("WEEKPLANNER.SHOWUNPLANNABLECASES"));
                    _this.dontShowRawDocusIfEmptyIsAllowed = _this.getValueGlobal("FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED") === "" ? _this.dontShowRawDocusIfEmptyIsAllowed : _this.convertToBool(_this.getValueGlobal("FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED"));
                    _this.inquireStampinOnLogin = _this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN") === "" ? _this.inquireStampinOnLogin : _this.convertToBool(_this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN"));
                    _this.inquireStampOutOnLogout = _this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT") === "" ? _this.inquireStampOutOnLogout : _this.convertToBool(_this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT"));
                    _this.flsCaseFilterWithDirectCarerAllocation = _this.getValueGlobal("FLS.CASE.FILTERWITHDIRECTALLOCATION") === "" ? _this.flsCaseFilterWithDirectCarerAllocation : _this.convertToBool(_this.getValueGlobal("FLS.CASE.FILTERWITHDIRECTALLOCATION"));
                    _this.saVaccination = _this.getValueGlobal("SMARTACTIONS.VACCINATION");
                    _this.saDocVisit = _this.getValueGlobal("SMARTACTIONS.DOCVISIT");
                    _this.saDisease = _this.getValueGlobal("SMARTACTIONS.DISEASE");
                    _this.saAppointment = _this.getValueGlobal("SMARTACTIONS.APPOINTMENT");
                    _this.saTask = _this.getValueGlobal("SMARTACTIONS.TASK");
                    _this.saAbsenteeism = _this.getValueGlobal("SMARTACTIONS.ABSENTEEISM");
                    _this.saMessage = _this.getValueGlobal("SMARTACTIONS.INTERNALMESSAGE");
                    _this.saDocument = _this.getValueGlobal("SMARTACTIONS.DOCUMENT");
                    _this.saAccountingBook = _this.getValueGlobal("SMARTACTIONS.ACCOUNTINGBOOK");
                    _this.saContactperson = _this.getValueGlobal("SMARTACTIONS.CONTACTPERSON");
                    _this.flsHideQuickDrivingCost = _this.getValueGlobal("FLS.HIDE_QUICK_DRIVINGCOST") === "" ? _this.flsHideQuickDrivingCost : _this.convertToBool(_this.getValueGlobal("FLS.HIDE_QUICK_DRIVINGCOST"));
                    _this.logoReroute = _this.getValueGlobal("LANDINGPAGE.LOGO") === "" ? _this.logoReroute : _this.convertToBool(_this.getValueGlobal("LANDINGPAGE.LOGO"));
                    _this.richTextImages = _this.getValueGlobal("RICHTEXTIMAGES") === "" ? _this.richTextImages : JSON.parse(_this.getValueGlobal("RICHTEXTIMAGES"));
                    _this.userService.getGlobalSettings(keysWin, false).then(function (data2) {
                        _this.globalSettingsWin = data2;
                        _this.flsAllowEmptyDrivingCost = _this.getValueGlobalWin("FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE") === "" ? _this.flsAllowEmptyDrivingCost : _this.convertToBool(_this.getValueGlobalWin("FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE"));
                        _this.defaultSigningPersonId = _this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGPERSON") === "" ? _this.defaultSigningPersonId : _this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGPERSON");
                        _this.defaultSigningReasonId = _this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASON") === "" ? _this.defaultSigningReasonId : _this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASON");
                        _this.defaultSigningReasonText = _this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT");
                        _this.flsSignatureReasonNotMandatory = _this.convertToBool(_this.getValueGlobalWin("FLS.SIGNATURE.REASONNOTMANDATORY"));
                        _this.flsDistributeHours = _this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN") === "" ? _this.flsDistributeHours : _this.convertToBool(_this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN"));
                        _this.flsDistributeHoursFix = _this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX") === "" ? _this.flsDistributeHoursFix : _this.convertToBool(_this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX"));
                        _this.flsResetTimeForManualDuration = _this.getValueGlobalWin("GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG") === "" ? _this.flsResetTimeForManualDuration : _this.convertToBool(_this.getValueGlobalWin("GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG"));
                        _this.serverJobPollingTimer = _this.getValueGlobalWin("SERVERJOBTIMERINTERVALLINSEC") === "" ? _this.serverJobPollingTimer : parseInt(_this.getValueGlobalWin("SERVERJOBTIMERINTERVALLINSEC"));
                        _this.AppointmentAddCalendarOnlyUsersEmployee = _this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.120000") === "" ? _this.AppointmentAddCalendarOnlyUsersEmployee : _this.convertToBool(_this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.120000"));
                        _this.AppointmentAddCalendarOnlyUsersClient = _this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.140000") === "" ? _this.AppointmentAddCalendarOnlyUsersClient : _this.convertToBool(_this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.140000"));
                        _this.AppointmentAddCalendarOnlyUsersAuthority = _this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.180000") === "" ? _this.AppointmentAddCalendarOnlyUsersAuthority : _this.convertToBool(_this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.180000"));
                        _this.flsPredfinedTitleMode = _this.getValueGlobalWin("FLS.DOKU.BERICHTTITELVORGABE") === "" ? _this.flsPredfinedTitleMode : _this.getValueGlobalWin("FLS.DOKU.BERICHTTITELVORGABE");
                        _this.flsPredfinedTitle = _this.getValueGlobalWin("FLS.DOKU.BERICHTTITEL") === "" ? _this.flsPredfinedTitle : _this.getValueGlobalWin("FLS.DOKU.BERICHTTITEL");
                        _this.rosterShowInactive = _this.getValueGlobalWin("DIENSTPLAN.SHOWINACTIVEPERSONS") === "" ? _this.rosterShowInactive : _this.convertToBool(_this.getValueGlobalWin("DIENSTPLAN.SHOWINACTIVEPERSONS"));
                        _this.flsShowManuelTime = _this.getValueGlobalWin("FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER") === "" ? _this.flsShowManuelTime : _this.convertToBool(_this.getValueGlobalWin("FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"));
                        _this.loading = false;
                    });
                });
            };
            UserGlobalSettingsController.prototype.saveSettings = function () {
                var _this = this;
                // Format values if needed
                this.loading = true;
                this.setValueGlobal("FLS.MINUTESTOSIGN", String(this.flsMinutesToSign));
                this.setValueGlobal("SECURITY.INACTIVITYTIMEOUT", String(this.inactivityTime));
                this.setValueGlobal("GLOBAL.LANDINGPAGE", this.landingPage);
                this.setValueGlobal("GLOBAL.SHOULDLOADTABLEDATA", String(this.shouldLoadTableData));
                this.setValueGlobal("GLOBAL.NAVIGATION.WEB", this.defaultNavId);
                this.setValueGlobal("FLS.SIGNATURE.BLOCK", String(this.blockSignatureModal));
                this.setValueGlobal("FLS.CASE.DAYSTOHIGHLIGHT", String(this.daysToHighlightCases));
                this.setValueGlobal("FLS.CONTINGENT.DONTSHOWINDRECT", String(this.dontShowIndirectHours));
                this.setValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY", String(this.createAdditionalFls));
                this.setValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT", this.createAdditionalFls ? this.createAdditionalFlsText : "");
                this.setValueGlobal("FLS.DOCUSUMMARYITEMS", String(this.flsDocuSummaryEntrys));
                this.setValueGlobal("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES", String(this.flsWeekplannerIncludeFutureCases));
                this.setValueGlobal("FLS.WEEKPLANNER_INCLUDE_PAST_CASES", String(this.flsWeekplannerIncludePastCases));
                this.setValueGlobal("WEEKPLANNER.SHOWUNPLANNABLECASES", String(this.weekplannerShowUnplannableCases));
                this.setValueGlobal("FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED", String(this.dontShowRawDocusIfEmptyIsAllowed));
                this.setValueGlobal("TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN", String(this.inquireStampinOnLogin));
                this.setValueGlobal("TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT", String(this.inquireStampinOnLogin));
                this.setValueGlobal("FLS.CASE.FILTERWITHDIRECTALLOCATION", String(this.flsCaseFilterWithDirectCarerAllocation));
                this.setValueGlobal("SMARTACTIONS.VACCINATION", this.saVaccination);
                this.setValueGlobal("SMARTACTIONS.DOCVISIT", this.saDocVisit);
                this.setValueGlobal("SMARTACTIONS.DISEASE", this.saDisease);
                this.setValueGlobal("SMARTACTIONS.APPOINTMENT", this.saAppointment);
                this.setValueGlobal("SMARTACTIONS.TASK", this.saTask);
                this.setValueGlobal("SMARTACTIONS.ABSENTEEISM", this.saAbsenteeism);
                this.setValueGlobal("SMARTACTIONS.INTERNALMESSAGE", this.saMessage);
                this.setValueGlobal("SMARTACTIONS.DOCUMENT", this.saDocument);
                this.setValueGlobal("SMARTACTIONS.ACCOUNTINGBOOK", this.saAccountingBook);
                this.setValueGlobal("SMARTACTIONS.CONTACTPERSON", this.saContactperson);
                this.setValueGlobal("FLS.HIDE_QUICK_DRIVINGCOST", String(this.flsHideQuickDrivingCost));
                this.setValueGlobal("LANDINGPAGE.LOGO", String(this.logoReroute));
                this.setValueGlobal("RICHTEXTIMAGES", JSON.stringify(this.richTextImages));
                this.setValueGlobalWin("FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE", String(this.flsAllowEmptyDrivingCost));
                this.setValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGPERSON", String(this.defaultSigningPersonId));
                this.setValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASON", String(this.defaultSigningReasonId));
                this.setValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT", this.flsSignatureReasonNotMandatory ? '' : this.defaultSigningReasonText);
                this.setValueGlobalWin("FLS.SIGNATURE.REASONNOTMANDATORY", String(this.flsSignatureReasonNotMandatory));
                this.setValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN", String(this.flsDistributeHours));
                this.setValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX", String(this.flsDistributeHoursFix));
                this.setValueGlobalWin("GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG", String(this.flsResetTimeForManualDuration));
                this.setValueGlobalWin("SERVERJOBTIMERINTERVALLINSEC", String(this.serverJobPollingTimer));
                this.setValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.120000", String(this.AppointmentAddCalendarOnlyUsersEmployee));
                this.setValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.140000", String(this.AppointmentAddCalendarOnlyUsersClient));
                this.setValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.180000", String(this.AppointmentAddCalendarOnlyUsersAuthority));
                this.setValueGlobalWin("FLS.DOKU.BERICHTTITELVORGABE", this.flsPredfinedTitleMode);
                this.setValueGlobalWin("FLS.DOKU.BERICHTTITEL", this.flsPredfinedTitleMode === '2' ? this.flsPredfinedTitle : '');
                this.setValueGlobalWin("DIENSTPLAN.SHOWINACTIVEPERSONS", String(this.rosterShowInactive));
                this.setValueGlobalWin("FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER", String(this.flsShowManuelTime));
                this.userService.setGlobalSettings({ settings: this.globalSettings }).then(function (data) {
                    _this.userService.setGlobalSettings({ settings: _this.globalSettingsWin }, false).then(function (data) {
                        _this.$qui.notify(_this.$qui.successNote);
                        _this.loading = false;
                        sessionStorage.removeItem('Setting.AutoLoadTables');
                        sessionStorage.removeItem(QMC.Common.Constants.SMARTACTIONCACHE);
                    });
                });
                window['snResizeSettings'] = this.richTextImages;
            };
            UserGlobalSettingsController.prototype.getLandingPages = function () {
                var _this = this;
                this.appStates = [];
                this.userService.getNavigationItems().then(function (data) {
                    var objectTypes = [];
                    for (var i = 0; i < data.length; i++) {
                        console.log(data[i], data[i].objectType);
                        objectTypes.push(data[i].objectType);
                    }
                    _this.permissionService.getPermissionsByObjectTypes(objectTypes).then(function (pData) {
                        for (var i = 0; i < data.length; i++)
                            if (data[i].objectType === 0 || _this.isAllowed(pData, data[i].objectType)) {
                                _this.appStates.push({
                                    text: _this.lng.translate(data[i].languageTag, data[i].caption),
                                    value: data[i].link
                                });
                            }
                        _this.appStates = _this.appStates.sort(function (a, b) {
                            var textA = a.text.toUpperCase();
                            var textB = b.text.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        _this.appStates.unshift({ text: "", value: "" });
                    });
                });
            };
            UserGlobalSettingsController = __decorate([
                QMC.Controller('QMC.Home', 'UserGlobalSettingsController'),
                QMC.Inject('$qui', '$scope', 'UserService', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService')
            ], UserGlobalSettingsController);
            return UserGlobalSettingsController;
        }());
        Home.UserGlobalSettingsController = UserGlobalSettingsController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var NewsFeedDirective = /** @class */ (function () {
            function NewsFeedDirective($http, $sce, userService) {
                var _this = this;
                this.$http = $http;
                this.$sce = $sce;
                this.userService = userService;
                this.restrict = 'E';
                this.templateUrl = './NewsFeed';
                this.replace = true;
                this.scope = {};
                this.ignoreNewsFeed = false;
                this.loading = {
                    feed: false,
                    setting: false
                };
                this.link = function (scope) {
                    scope.ignore = false;
                    scope.loadLink = false;
                    _this.loading.feed = true;
                    scope.feed = [];
                    _this.loading.setting = true;
                    _this.userService.getUserSettings(['NEWSFEED.LAST', 'NEWSFEED.IGNORE', 'NEWSFEED.URL']).then(function (dataSettings) {
                        if (dataSettings[0] !== '')
                            _this.lastMessageId = dataSettings[0].value;
                        _this.ignoreNewsFeed = dataSettings[1].value.toLowerCase().trim() === 'true';
                        _this.loading.setting = false;
                        scope.ignore = dataSettings[1].value.toLowerCase() === 'true';
                        var url = dataSettings[2].value !== '' ? dataSettings[2].value : 'https://update.qmcenter.de/technews-de.xml';
                        _this.$http({
                            url: url,
                            method: 'GET',
                            cache: false,
                            headers: { 'Content-Type': 'application/xml' },
                            transformResponse: function (data) { return $.parseXML(data); }
                        }).then(function (res) {
                            var items = res.data.getElementsByTagName('item');
                            for (var i = 0; i < items.length; i++) {
                                var item = items[i];
                                if (!item)
                                    continue;
                                scope.feed.push({
                                    title: _this.$sce.trustAsHtml(item.getElementsByTagName('title')[0] ? item.getElementsByTagName('title')[0].innerHTML : ''),
                                    text: _this.$sce.trustAsHtml(item.getElementsByTagName('description')[0] ? item.getElementsByTagName('description')[0].innerHTML.replace(']]>', '') : ''),
                                    link: item.getElementsByTagName('link')[0] ? item.getElementsByTagName('link')[0].textContent : '',
                                    date: _this.uniqueDate(scope.feed, item.getElementsByTagName('pubDate')[0] ? item.getElementsByTagName('pubDate')[0].textContent : '')
                                });
                            }
                            _this.loading.feed = false;
                            if (scope.feed.length > 0) {
                                scope.current = scope.feed[0];
                                _this.showNewsFeed(scope);
                                scope.selectedItem = scope.current.date;
                            }
                        });
                    });
                    scope.dismiss = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var settings = {
                            settings: [
                                { key: 'NEWSFEED.LAST', value: scope.feed[0].date },
                                { key: 'NEWSFEED.IGNORE', value: args[1].toString() }
                            ]
                        };
                        this.userService.setUserSettings(settings).then(function () { });
                        $('#newsFeedModal').modal('hide');
                    }.bind(_this, _this);
                    scope.$watch('selectedItem', function (newValue, oldValue) {
                        if (newValue === oldValue)
                            return;
                        for (var _i = 0, _a = scope.feed; _i < _a.length; _i++) {
                            var news = _a[_i];
                            if (news.date === newValue) {
                                scope.current = news;
                                if (document.getElementById('newsFeedExternalContent') && $('#newsFeedModal').hasClass('in'))
                                    document.getElementById('newsFeedExternalContent').setAttribute('src', news.link);
                                break;
                            }
                        }
                    });
                    scope.openModal = function () {
                        $('#newsFeedModal').modal('show');
                        document.getElementById('newsFeedExternalContent').setAttribute('src', scope.current.link);
                    };
                };
            }
            NewsFeedDirective.prototype.showNewsFeed = function (scope) {
                var _a;
                if (this.loading.feed || this.loading.setting || this.ignoreNewsFeed || this.lastMessageId === scope.current.date)
                    return;
                $('#newsFeedModal').modal('show');
                document.getElementById('newsFeedExternalContent').setAttribute('src', (_a = scope.current) === null || _a === void 0 ? void 0 : _a.link);
            };
            NewsFeedDirective.prototype.uniqueDate = function (feed, date) {
                if (date.length === 0)
                    date = new Date().toString();
                for (var _i = 0, feed_1 = feed; _i < feed_1.length; _i++) {
                    var item = feed_1[_i];
                    if (item.date === date) {
                        date = date + "_";
                    }
                }
                return date;
            };
            NewsFeedDirective = __decorate([
                QMC.Directive('QMC.Home', 'qmNewsFeed', ['$http', '$sce', 'UserService'])
            ], NewsFeedDirective);
            return NewsFeedDirective;
        }());
        Home.NewsFeedDirective = NewsFeedDirective;
        ;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var VersionDirective = /** @class */ (function () {
            function VersionDirective($location, userService) {
                var _this = this;
                this.$location = $location;
                this.userService = userService;
                this.restrict = 'E';
                this.templateUrl = './version';
                this.replace = true;
                this.scope = {
                    versionInfo: '@',
                };
                this.link = function (scope) {
                    _this.getVersions(scope);
                };
            }
            VersionDirective.prototype.getVersions = function (scope) {
                this.userService.getVersionInfo().then(function (data) {
                    scope.versionInfo = data;
                    if (data.webClientVersion.substring(0, 3) != data.qmcServerVersion.substring(0, 3))
                        $('#versionErrorModal').modal('show');
                }).catch(function (data) {
                    if (JSON.stringify(data).toLocaleLowerCase().indexOf("txtext") > 0 || data == 500) {
                        setTimeout(function () {
                            $('#serverErrorModal').modal('show');
                        }, 5000);
                    }
                });
            };
            VersionDirective = __decorate([
                QMC.Directive('QMC.Home', 'qmVersion', ['$location', 'UserService'])
            ], VersionDirective);
            return VersionDirective;
        }());
        Home.VersionDirective = VersionDirective;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var ChangelogController = /** @class */ (function () {
            /**
             * QMC.Home.Changelog
             * @constructor
             * @param $location
             * @param $timeout
             * @param $qui
             */
            function ChangelogController($http, $location, $timeout, $qui, userService) {
                var _this = this;
                this.$http = $http;
                this.$location = $location;
                this.$timeout = $timeout;
                this.$qui = $qui;
                this.userService = userService;
                this.versions = [];
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.userService.getVersionInfo().then(function (data) {
                    var splitted = data.webClientVersion.split('.');
                    console.log(data, splitted);
                    for (var base = splitted[0]; base >= 6; base--) {
                        for (var sub = splitted[1]; sub >= 0; sub--) {
                            _this.versions.push({
                                base: base,
                                sub: sub,
                                url: 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                    + base + '-' + sub + '/',
                                newest: base === splitted[0] && sub === splitted[1],
                                loaded: false
                            });
                        }
                    }
                    for (var i = 3; i >= 0; i--) {
                        _this.versions.push({
                            base: 5,
                            sub: i,
                            url: 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                + 5 + '-' + i + '/',
                            newest: false,
                            loaded: false
                        });
                    }
                    for (var i = 5; i >= 0; i--) {
                        _this.versions.push({
                            base: 4,
                            sub: i,
                            url: 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                + 4 + '-' + i + '/',
                            newest: false,
                            loaded: false
                        });
                    }
                    for (var i = 14; i >= 2; i--) {
                        _this.versions.push({
                            base: 3,
                            sub: i,
                            url: (i > 8
                                ? 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                : 'https://service.daarwin.de/changelogs/changelog-daarwin-web-')
                                + 3 + '-' + i + '/',
                            newest: false,
                            loaded: false
                        });
                    }
                    console.log(_this.versions);
                });
            }
            ChangelogController = __decorate([
                QMC.Controller('QMC.Home', 'ChangelogController'),
                QMC.Inject('$http', '$location', '$timeout', '$qui', 'UserService')
            ], ChangelogController);
            return ChangelogController;
        }());
        Home.ChangelogController = ChangelogController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../maps/qmc.home.js.map
